document.addEventListener('change', function (e) {
  if (!e.target.matches('input[name^="options"]')) return;
  if (e.target.closest('#customily-options, .customily-modal-preview-only')) return;

  const form = e.target.closest('form');
  if (!form) return;

  const selectedOptions = Array.from(
    form.querySelectorAll('input[name^="options"]:checked')
  ).map(input => input.value);

  const variants = window.productVariants || [];

  const found = variants.find(variant =>
    variant.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!found) return;

  form.querySelector('[name="id"]').value = found.id;

  const variantSelects = document.querySelector('variant-selects');

  if (variantSelects) {
    variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
  }

  document.dispatchEvent(new CustomEvent('variant:change', {
    detail: { variant: found }
  }));

  if (found.featured_media) {
    const mediaId = found.featured_media.id;

    document.querySelectorAll('[data-media-id]').forEach(el => {
      el.classList.remove('is-active');

      if (el.dataset.mediaId == mediaId) {
        el.classList.add('is-active');
      }
    });
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const observedPriceRoots = new WeakSet();
  let priceNormalizeRaf = 0;
  const priceObserver = window.MutationObserver
    ? new MutationObserver(function () {
        scheduleRemoveFromText();
      })
    : null;

  function removeFromText(root) {
    (root || document).querySelectorAll('.price-item').forEach(function (el) {
      const normalizedText = el.textContent.replace('From ', '').trim();
      if (el.textContent !== normalizedText) {
        el.textContent = normalizedText;
      }
    });
  }

  function observePriceRoots(root) {
    if (!priceObserver) return;

    (root || document).querySelectorAll('.price, [id^="price-"]').forEach(function (priceRoot) {
      if (observedPriceRoots.has(priceRoot)) return;

      observedPriceRoots.add(priceRoot);
      priceObserver.observe(priceRoot, {
        childList: true,
        characterData: true,
        subtree: true
      });
    });
  }

  function scheduleRemoveFromText(root) {
    window.cancelAnimationFrame(priceNormalizeRaf);
    priceNormalizeRaf = window.requestAnimationFrame(function () {
      priceNormalizeRaf = 0;
      removeFromText(root || document);
      observePriceRoots(root || document);
    });
  }

  scheduleRemoveFromText();
  document.addEventListener('shopify:section:load', function (event) {
    scheduleRemoveFromText(event.target);
  });
});

document.addEventListener('scroll', function () {
  const header = document.querySelector('sticky-header.header-wrapper');
  const currentScrollY = window.scrollY;
  const isScrolled = currentScrollY > 10;

  document.documentElement.classList.toggle('macorner-header-scrolled', isScrolled);

  if (header) {
    if (isScrolled) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  }
});

(function () {
  const customilyInputSelector = '#customily-options input, #customily-options textarea, #customily-options select';
  const customilyPreviewSelector = '#pwzrswiper-container-wrapper, .rio-media-gallery, .cl-canvas-container';
  const productWizGallerySelector = '#pwzrswiper-container-wrapper';
  const productMediaThumbnailSelector = [
    '.rio-media-gallery .rio-hide-scrollbar',
    '.product__media-wrapper > .rio-media-gallery [class*="thumb"]',
    '.product__media-wrapper > .rio-media-gallery [class*="Thumb"]',
    '.product__media-wrapper > .rio-media-gallery .rio-hide-scrollbar *',
    '.product__media-wrapper > .rio-media-gallery [aria-label*="thumbnail"]',
    '.product__media-wrapper > .rio-media-gallery [aria-label*="Thumbnail"]',
    'media-gallery [id^="GalleryThumbnails"]',
    '.product__media-wrapper [id^="GalleryThumbnails"]',
    '.product__media-wrapper .thumbnail-slider',
    '.product__media-wrapper .thumbnail-list'
  ].join(',');
  const normalizeDelays = [50, 150, 350, 700, 1000];
  const interactionSettleDelay = 450;
  const thumbnailScrollSuppressDelay = 1400;
  const thumbnailScrollThreshold = 5;
  let normalizeTimers = [];
  let normalizeRaf = 0;
  let isNormalizingCustomilyPreview = false;
  let isInteractingWithCustomilyPreview = false;
  let interactionTimer = 0;
  let thumbnailGesture = null;
  let suppressedThumbnailRoot = null;
  let suppressThumbnailClickUntil = 0;
  let mainMediaGesture = null;
  let suppressedMainMediaRoot = null;
  let suppressMainMediaClickUntil = 0;
  let overlaySyncTimer = 0;

  function getElementFromNode(node) {
    if (!node) return null;
    return node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
  }

  function mutationTouchesCustomilyPreview(mutation) {
    const target = getElementFromNode(mutation.target);
    if (target?.closest(customilyPreviewSelector)) return true;

    return Array.from(mutation.addedNodes).some((node) => {
      const element = getElementFromNode(node);

      return element?.matches?.(customilyPreviewSelector) || element?.querySelector?.(customilyPreviewSelector);
    });
  }

  function setImportantStyle(element, property, value) {
    if (
      element.style.getPropertyValue(property) === value &&
      element.style.getPropertyPriority(property) === 'important'
    ) {
      return;
    }

    element.style.setProperty(property, value, 'important');
  }

  function clearNormalizeSchedule() {
    window.cancelAnimationFrame(normalizeRaf);
    normalizeTimers.forEach((timer) => window.clearTimeout(timer));
    normalizeTimers = [];
  }

  function getActiveProductWizSlideIndex() {
    const gallery = document.querySelector(productWizGallerySelector);
    const activeSlide = gallery?.querySelector('.pwzrswiper-slide-active');

    if (!activeSlide) return -1;

    const idIndex = activeSlide.id?.match(/pwzrswiper-slide-(\d+)/)?.[1];
    if (idIndex) return Number(idIndex);

    return Array.from(gallery.querySelectorAll('.pwzrswiper-slide')).indexOf(activeSlide);
  }

  function syncCustomilyOverlayWithProductGallery() {
    const activeIndex = getActiveProductWizSlideIndex();

    document.body.classList.toggle('dm-productwiz-gallery-media-active', activeIndex > 0);
  }

  function scheduleCustomilyOverlaySync() {
    window.clearTimeout(overlaySyncTimer);
    window.requestAnimationFrame(syncCustomilyOverlayWithProductGallery);
    overlaySyncTimer = window.setTimeout(syncCustomilyOverlayWithProductGallery, 120);
  }

  function markCustomilyEditingActive() {
    document.body.classList.add('dm-customily-editing-active');
    scheduleCustomilyOverlaySync();
  }

  function clearCustomilyEditingActive() {
    document.body.classList.remove('dm-customily-editing-active');
  }

  function eventTouchesCustomilyPreview(event) {
    return event.target instanceof Element && Boolean(event.target.closest(customilyPreviewSelector));
  }

  function eventTouchesProductMediaThumbnails(event) {
    if (!(event.target instanceof Element)) return false;
    if (event.target.closest(productMediaThumbnailSelector)) return true;

    return Boolean(suppressedThumbnailRoot?.contains(event.target));
  }

  function getInteractionPoint(event) {
    const touch = event.touches?.[0] || event.changedTouches?.[0];
    const point = touch || event;

    if (typeof point.clientX !== 'number' || typeof point.clientY !== 'number') return null;

    return {
      x: point.clientX,
      y: point.clientY
    };
  }

  function isMobileViewport() {
    return window.matchMedia?.('(max-width: 749px)').matches;
  }

  function pauseCustomilyPreviewNormalization() {
    isInteractingWithCustomilyPreview = true;
    clearNormalizeSchedule();
    window.clearTimeout(interactionTimer);
  }

  function resumeCustomilyPreviewNormalization() {
    if (!isInteractingWithCustomilyPreview) return;

    window.clearTimeout(interactionTimer);
    interactionTimer = window.setTimeout(function () {
      isInteractingWithCustomilyPreview = false;
      scheduleNormalizeCustomilyPreview();
    }, interactionSettleDelay);
  }

  function handleCustomilyPreviewInteractionStart(event) {
    if (!eventTouchesCustomilyPreview(event)) return;
    pauseCustomilyPreviewNormalization();
  }

  function handleCustomilyPreviewInteractionEnd() {
    resumeCustomilyPreviewNormalization();
  }

  function handleProductMediaThumbnailGestureStart(event) {
    if (!isMobileViewport() || !eventTouchesProductMediaThumbnails(event)) return;

    const point = getInteractionPoint(event);
    if (!point) return;

    thumbnailGesture = {
      startX: point.x,
      startY: point.y,
      startScrollX: window.scrollX,
      startScrollY: window.scrollY,
      root: event.target.closest(productMediaThumbnailSelector),
      didScrollDrag: false
    };
  }

  function markProductMediaThumbnailScrollDrag() {
    if (!thumbnailGesture) return;

    thumbnailGesture.didScrollDrag = true;
    suppressedThumbnailRoot = thumbnailGesture.root;
    suppressThumbnailClickUntil = Date.now() + thumbnailScrollSuppressDelay;
  }

  function handleProductMediaThumbnailGestureMove(event) {
    if (!thumbnailGesture) return;

    const point = getInteractionPoint(event);
    if (!point) return;

    const deltaX = Math.abs(point.x - thumbnailGesture.startX);
    const deltaY = Math.abs(point.y - thumbnailGesture.startY);

    if (Math.max(deltaX, deltaY) >= thumbnailScrollThreshold) {
      markProductMediaThumbnailScrollDrag();
      stopProductMediaThumbnailEvent(event, false);
    }
  }

  function handleProductMediaThumbnailWindowScroll() {
    if (!thumbnailGesture) return;

    const deltaScrollY = Math.abs(window.scrollY - thumbnailGesture.startScrollY);
    const deltaScrollX = Math.abs(window.scrollX - thumbnailGesture.startScrollX);

    if (deltaScrollY >= 1 && deltaScrollY >= deltaScrollX) {
      markProductMediaThumbnailScrollDrag();
    }
  }

  function stopProductMediaThumbnailEvent(event, preventDefault = true) {
    if (!eventTouchesProductMediaThumbnails(event)) return;

    if (preventDefault && event.cancelable) {
      event.preventDefault();
    }

    event.stopImmediatePropagation();
  }

  function handleProductMediaThumbnailGestureEnd(event) {
    if (!thumbnailGesture) {
      if (Date.now() <= suppressThumbnailClickUntil) {
        stopProductMediaThumbnailEvent(event);
      }

      return;
    }

    if (thumbnailGesture.didScrollDrag) {
      markProductMediaThumbnailScrollDrag();
      stopProductMediaThumbnailEvent(event);
      scheduleCustomilyOverlaySync();
    }

    thumbnailGesture = null;
  }

  function handleProductMediaThumbnailClick(event) {
    if (!eventTouchesProductMediaThumbnails(event)) return;

    if (Date.now() > suppressThumbnailClickUntil) {
      suppressedThumbnailRoot = null;
      clearCustomilyEditingActive();
      scheduleCustomilyOverlaySync();
      return;
    }

    stopProductMediaThumbnailEvent(event);
  }

  function isElementVisible(element) {
    if (!element) return false;

    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);

    return rect.width > 0 && rect.height > 0 && style.visibility !== 'hidden' && style.display !== 'none';
  }

  function getProductWizMainMediaRoot(event) {
    if (!(event.target instanceof Element)) return null;
    if (eventTouchesProductMediaThumbnails(event)) return null;
    if (event.target.closest('button, a, input, select, textarea, video, iframe, model-viewer')) return null;

    const gallery = event.target.closest('.product__media-wrapper > .rio-media-gallery');
    if (!gallery) return null;

    const root =
      event.target.closest('#pwzrswiper-container-wrapper, .pwzrswiper-container, .swiper, .swiper-container') ||
      gallery.querySelector('#pwzrswiper-container-wrapper, .pwzrswiper-container, .swiper, .swiper-container');

    return root && isElementVisible(root) ? root : null;
  }

  function getProductWizSwiper(root) {
    const candidates = [
      root,
      root.querySelector('.pwzrswiper-container'),
      root.querySelector('.swiper'),
      root.querySelector('.swiper-container')
    ].filter(Boolean);

    for (const candidate of candidates) {
      const swiper = candidate.swiper || candidate.pwzrswiper;

      if (swiper && typeof swiper.slideNext === 'function' && typeof swiper.slidePrev === 'function') {
        return swiper;
      }
    }

    return null;
  }

  function getProductWizActiveMediaKey(root) {
    const swiper = getProductWizSwiper(root);
    if (swiper) {
      const index = swiper.realIndex ?? swiper.activeIndex ?? swiper.snapIndex;

      if (index !== undefined) return `swiper:${index}`;
    }

    const activeSlide = root.querySelector(
      '.pwzrswiper-slide-active, .swiper-slide-active, [aria-current="true"], [aria-selected="true"], .is-active, .active'
    );
    if (activeSlide) {
      return activeSlide.id || activeSlide.dataset?.mediaId || activeSlide.dataset?.swiperSlideIndex || activeSlide.textContent || 'active';
    }

    return `scroll:${Math.round(root.scrollLeft || 0)}`;
  }

  function getProductWizDirectionalButton(root, direction) {
    const directionText = direction > 0 ? 'next' : 'previous';
    const fallbackDirectionText = direction > 0 ? 'right' : 'left';
    const selector = [
      direction > 0 ? '.pwzrswiper-button-next' : '.pwzrswiper-button-prev',
      direction > 0 ? '.swiper-button-next' : '.swiper-button-prev',
      `button[aria-label*="${directionText}" i]`,
      `[role="button"][aria-label*="${directionText}" i]`,
      `button[aria-label*="${fallbackDirectionText}" i]`,
      `[role="button"][aria-label*="${fallbackDirectionText}" i]`
    ].join(',');

    return Array.from(root.querySelectorAll(selector)).find((button) => {
      return (
        isElementVisible(button) &&
        !button.matches('[disabled], .swiper-button-disabled, .pwzrswiper-button-disabled') &&
        !button.closest('.rio-hide-scrollbar')
      );
    });
  }

  function moveProductWizMainMedia(root, direction) {
    const swiper = getProductWizSwiper(root);

    if (swiper) {
      if (direction > 0) swiper.slideNext();
      else swiper.slidePrev();
      return true;
    }

    const button = getProductWizDirectionalButton(root, direction);
    if (!button) return false;

    button.click();
    return true;
  }

  function handleProductWizMainSwipeStart(event) {
    const root = getProductWizMainMediaRoot(event);
    if (!root) return;

    const point = getInteractionPoint(event);
    if (!point) return;

    mainMediaGesture = {
      root,
      pointerId: event.pointerId,
      startX: point.x,
      startY: point.y,
      startMediaKey: getProductWizActiveMediaKey(root),
      isDragging: false
    };
  }

  function handleProductWizMainSwipeMove(event) {
    if (!mainMediaGesture) return;
    if (mainMediaGesture.pointerId !== undefined && event.pointerId !== mainMediaGesture.pointerId) return;

    const point = getInteractionPoint(event);
    if (!point) return;

    const deltaX = point.x - mainMediaGesture.startX;
    const deltaY = point.y - mainMediaGesture.startY;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);

    if (absY > 24 && absY > absX) {
      mainMediaGesture = null;
      return;
    }

    if (absX > 12 && absX > absY * 1.2) {
      mainMediaGesture.isDragging = true;
      mainMediaGesture.root.classList.add('is-main-media-swiping');
    }
  }

  function handleProductWizMainSwipeEnd(event) {
    if (event.type === 'pointercancel') {
      mainMediaGesture?.root.classList.remove('is-main-media-swiping');
      mainMediaGesture = null;
      return;
    }

    if (!mainMediaGesture) {
      if (Date.now() <= suppressMainMediaClickUntil) stopProductWizMainSwipeClick(event);
      return;
    }
    if (mainMediaGesture.pointerId !== undefined && event.pointerId !== mainMediaGesture.pointerId) return;

    const point = getInteractionPoint(event);
    const gesture = mainMediaGesture;
    mainMediaGesture = null;
    gesture.root.classList.remove('is-main-media-swiping');

    if (!point) return;

    const deltaX = point.x - gesture.startX;
    const deltaY = point.y - gesture.startY;
    const absX = Math.abs(deltaX);
    const absY = Math.abs(deltaY);
    const shouldMove = gesture.isDragging && absX > 44 && absX > absY * 1.35;

    if (!shouldMove) return;

    suppressedMainMediaRoot = gesture.root;
    suppressMainMediaClickUntil = Date.now() + 300;

    window.setTimeout(() => {
      if (!gesture.root.isConnected) return;

      if (getProductWizActiveMediaKey(gesture.root) === gesture.startMediaKey) {
        moveProductWizMainMedia(gesture.root, deltaX < 0 ? 1 : -1);
      }

      scheduleCustomilyOverlaySync();
    }, 80);
  }

  function stopProductWizMainSwipeClick(event) {
    if (!suppressedMainMediaRoot?.contains(event.target)) return;

    if (event.cancelable) event.preventDefault();
    event.stopImmediatePropagation();
  }

  function handleProductWizMainSwipeClick(event) {
    if (Date.now() > suppressMainMediaClickUntil) {
      suppressedMainMediaRoot = null;
      return;
    }

    stopProductWizMainSwipeClick(event);
  }

  function getRoundedHeight(element) {
    if (!element) return 0;
    return Math.ceil(element.getBoundingClientRect().height);
  }

  function normalizeCustomilyProductWizPreview() {
    if (isNormalizingCustomilyPreview) return;
    if (isInteractingWithCustomilyPreview) return;
    if (
      document.body.classList.contains('dm-customily-preview-pending') ||
      document.body.classList.contains('dm-customily-preview-open') ||
      document.body.classList.contains('dm-customily-photo-editor-open')
    ) return;

    const gallery = document.querySelector('#pwzrswiper-container-wrapper .pwzrswiper-container');
    const customilyOverlay = gallery?.querySelector('.cl-canvas-container');
    const canvasWrapper = customilyOverlay?.querySelector('.canvas-wrapper');
    const canvasContainer = customilyOverlay?.querySelector('.canvas-container');
    const swiperWrapper = gallery?.querySelector('.pwzrswiper-wrapper');
    const galleryWrapper = document.querySelector('#pwzrswiper-container-wrapper');

    if (!gallery || !customilyOverlay || !canvasWrapper || !canvasContainer || !swiperWrapper || !galleryWrapper) return;

    const canvasHeight = getRoundedHeight(canvasWrapper) || getRoundedHeight(canvasContainer);
    if (!canvasHeight) return;

    const overlayHeight = getRoundedHeight(customilyOverlay);
    const overlayTop = Math.round(customilyOverlay.getBoundingClientRect().top);
    const canvasTop = Math.round(canvasWrapper.getBoundingClientRect().top);
    const wrapperMinHeight = parseFloat(getComputedStyle(swiperWrapper).minHeight) || 0;

    const needsNormalization =
      overlayHeight > canvasHeight + 4 ||
      wrapperMinHeight > canvasHeight + 4 ||
      Math.abs(canvasTop - overlayTop) > 2;

    if (!needsNormalization) return;

    const normalizedHeight = `${canvasHeight}px`;

    isNormalizingCustomilyPreview = true;
    setImportantStyle(customilyOverlay, 'height', normalizedHeight);
    setImportantStyle(customilyOverlay, 'align-items', 'flex-start');
    setImportantStyle(customilyOverlay, 'justify-content', 'flex-start');
    setImportantStyle(canvasWrapper, 'margin-top', '0');
    setImportantStyle(canvasContainer, 'opacity', '1');
    setImportantStyle(swiperWrapper, 'min-height', normalizedHeight);
    setImportantStyle(swiperWrapper, 'height', normalizedHeight);
    setImportantStyle(gallery, 'height', normalizedHeight);
    setImportantStyle(galleryWrapper, 'height', normalizedHeight);

    window.requestAnimationFrame(function () {
      isNormalizingCustomilyPreview = false;
    });
  }

  function scheduleNormalizeCustomilyPreview() {
    if (isNormalizingCustomilyPreview) return;
    if (isInteractingWithCustomilyPreview) return;

    clearNormalizeSchedule();

    normalizeRaf = window.requestAnimationFrame(normalizeCustomilyProductWizPreview);
    normalizeTimers = normalizeDelays.map(function (delay) {
      return window.setTimeout(normalizeCustomilyProductWizPreview, delay);
    });
  }

  document.addEventListener('input', function (event) {
    if (!event.target.matches(customilyInputSelector)) return;
    markCustomilyEditingActive();
    scheduleNormalizeCustomilyPreview();
  }, true);

  document.addEventListener('change', function (event) {
    if (!event.target.matches(customilyInputSelector)) return;
    markCustomilyEditingActive();
    scheduleNormalizeCustomilyPreview();
  }, true);

  window.addEventListener('resize', scheduleNormalizeCustomilyPreview);
  document.addEventListener('touchstart', handleCustomilyPreviewInteractionStart, { capture: true, passive: true });
  document.addEventListener('touchmove', handleCustomilyPreviewInteractionStart, { capture: true, passive: true });
  document.addEventListener('touchend', handleCustomilyPreviewInteractionEnd, { capture: true, passive: true });
  document.addEventListener('touchcancel', handleCustomilyPreviewInteractionEnd, { capture: true, passive: true });
  document.addEventListener('pointerdown', handleCustomilyPreviewInteractionStart, { capture: true, passive: true });
  document.addEventListener('pointermove', handleCustomilyPreviewInteractionStart, { capture: true, passive: true });
  document.addEventListener('pointerup', handleCustomilyPreviewInteractionEnd, { capture: true, passive: true });
  document.addEventListener('pointercancel', handleCustomilyPreviewInteractionEnd, { capture: true, passive: true });
  document.addEventListener('touchstart', handleProductMediaThumbnailGestureStart, { capture: true, passive: true });
  document.addEventListener('touchmove', handleProductMediaThumbnailGestureMove, { capture: true, passive: true });
  document.addEventListener('touchend', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  document.addEventListener('touchcancel', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  document.addEventListener('pointerdown', handleProductMediaThumbnailGestureStart, { capture: true, passive: true });
  document.addEventListener('pointermove', handleProductMediaThumbnailGestureMove, { capture: true, passive: true });
  document.addEventListener('pointerup', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  document.addEventListener('pointercancel', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  document.addEventListener('mousedown', handleProductMediaThumbnailGestureStart, { capture: true, passive: true });
  document.addEventListener('mousemove', handleProductMediaThumbnailGestureMove, { capture: true, passive: true });
  document.addEventListener('mouseup', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  document.addEventListener('click', handleProductMediaThumbnailClick, true);
  document.addEventListener('pointerdown', handleProductWizMainSwipeStart, { capture: true, passive: true });
  document.addEventListener('pointermove', handleProductWizMainSwipeMove, { capture: true, passive: true });
  document.addEventListener('pointerup', handleProductWizMainSwipeEnd, { capture: true, passive: false });
  document.addEventListener('pointercancel', handleProductWizMainSwipeEnd, { capture: true, passive: false });
  document.addEventListener('click', handleProductWizMainSwipeClick, true);
  window.addEventListener('touchstart', handleProductMediaThumbnailGestureStart, { capture: true, passive: true });
  window.addEventListener('touchmove', handleProductMediaThumbnailGestureMove, { capture: true, passive: true });
  window.addEventListener('touchend', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  window.addEventListener('touchcancel', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  window.addEventListener('pointerdown', handleProductMediaThumbnailGestureStart, { capture: true, passive: true });
  window.addEventListener('pointermove', handleProductMediaThumbnailGestureMove, { capture: true, passive: true });
  window.addEventListener('pointerup', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  window.addEventListener('pointercancel', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  window.addEventListener('mousedown', handleProductMediaThumbnailGestureStart, { capture: true, passive: true });
  window.addEventListener('mousemove', handleProductMediaThumbnailGestureMove, { capture: true, passive: true });
  window.addEventListener('mouseup', handleProductMediaThumbnailGestureEnd, { capture: true, passive: false });
  window.addEventListener('click', handleProductMediaThumbnailClick, true);
  window.addEventListener('scroll', handleProductMediaThumbnailWindowScroll, { passive: true });
  window.addEventListener('scroll', resumeCustomilyPreviewNormalization, { passive: true });

  document.addEventListener('DOMContentLoaded', function () {
    const mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper || !window.MutationObserver) return;

    const observer = new MutationObserver(function (mutations) {
      if (isNormalizingCustomilyPreview) return;
      if (!mutations.some(mutationTouchesCustomilyPreview)) return;

      scheduleCustomilyOverlaySync();
      scheduleNormalizeCustomilyPreview();
    });
    observer.observe(mediaWrapper, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });
    scheduleCustomilyOverlaySync();
  });
  window.addEventListener('load', scheduleCustomilyOverlaySync);
})();

/* Mobile product media sticky preview */
(function () {
  const MOBILE_MEDIA_QUERY = '(max-width: 749px)';
  const STICKY_CLASS = 'dm-mobile-media-sticky';
  const OPEN_CLASS = 'dm-mobile-media-sticky-open';
  const CUSTOMILY_PREVIEW_SELECTORS = [
    '.cl-canvas-container .canvas-wrapper #preview-canvas',
    '.cl-canvas-container .canvas-wrapper canvas',
    '.cl-canvas-container .canvas-container canvas',
    '.cl-canvas-container #preview-canvas'
  ];
  const MODAL_BODY_CLASSES = [
    'dm-customily-upload-processing-open',
    'dm-customily-photo-editor-open',
    'dm-customily-preview-open',
    'dm-customily-preview-pending'
  ];

  let stickyPreview = null;
  let currentProduct = null;
  let customilySource = null;
  let customilyPreviewBoundary = null;
  let reviewsBoundary = null;
  let dismissed = false;
  let zoom = 1;
  let panX = 0;
  let panY = 0;
  let dragState = null;
  let pinchState = null;
  let zoomInteractionScrollY = null;
  let restoreInteractionScrollY = null;
  let manualRestoreActive = false;
  let manualRestoreIgnoreScrollUntil = 0;
  let manualCloseActive = false;
  let zoomInteractionActive = false;
  let zoomInteractionIgnoreScrollUntil = 0;
  let frame = 0;
  let mirrorFrame = 0;
  let observer = null;
  let largestVisualViewportHeight = 0;
  let lastVisualViewportWidth = 0;

  function syncMobileVisualViewport() {
    const root = document.documentElement;
    const visualViewport = window.visualViewport;
    const isMobile = window.matchMedia(MOBILE_MEDIA_QUERY).matches;

    if (!isMobile || !visualViewport) {
      root.style.removeProperty('--dm-mobile-visual-viewport-top');
      root.style.removeProperty('--dm-mobile-visual-viewport-height');
      document.body?.classList.remove('dm-mobile-keyboard-open');
      largestVisualViewportHeight = 0;
      lastVisualViewportWidth = 0;
      return;
    }

    if (lastVisualViewportWidth && Math.abs(visualViewport.width - lastVisualViewportWidth) > 80) {
      largestVisualViewportHeight = 0;
    }

    lastVisualViewportWidth = visualViewport.width;
    largestVisualViewportHeight = Math.max(largestVisualViewportHeight, visualViewport.height);

    const layoutViewportHeight = Math.max(
      document.documentElement.clientHeight,
      window.innerHeight,
      largestVisualViewportHeight
    );
    const keyboardIsOpen = layoutViewportHeight - visualViewport.height > 140;

    root.style.setProperty(
      '--dm-mobile-visual-viewport-top',
      `${Math.max(0, visualViewport.offsetTop)}px`
    );
    root.style.setProperty(
      '--dm-mobile-visual-viewport-height',
      `${Math.max(0, visualViewport.height)}px`
    );
    document.body?.classList.toggle('dm-mobile-keyboard-open', keyboardIsOpen);

    clampPan();
    applyStickyTransform();
    scheduleUpdate();
  }

  function findCustomilyPreview() {
    for (const selector of CUSTOMILY_PREVIEW_SELECTORS) {
      const match = Array.from(document.querySelectorAll(selector)).find((element) => {
        return element instanceof HTMLCanvasElement && element.width > 0 && element.height > 0;
      });
      if (match) {
        return {
          source: match,
          boundary: match.closest('.cl-canvas-container') || match.closest('.canvas-wrapper') || match
        };
      }
    }
    return null;
  }

  function hasCustomilyActivity() {
    const root = currentProduct?.querySelector('#customily-options');
    return Boolean(
      document.body.classList.contains('dm-customily-editing-active') ||
      root?.classList.contains('dm-customily-upload-has-file') ||
      root?.querySelector('.dm-customily-upload-control-wrap--has-file, .customily-file-with-thumbnail')
    );
  }

  function getAssetUrl(filename) {
    const script = Array.from(document.scripts).find((item) => item.src.includes('/assets/main.js'));
    if (!script) return '';
    return script.src.replace(/main\.js(?:\?.*)?$/, filename);
  }

  function ensureStickyPreview() {
    if (stickyPreview?.isConnected) return stickyPreview;

    stickyPreview = document.createElement('aside');
    stickyPreview.className = STICKY_CLASS;
    stickyPreview.setAttribute('aria-label', 'Customily personalization preview');
    stickyPreview.setAttribute('aria-hidden', 'true');
    stickyPreview.innerHTML = `
      <div class="dm-mobile-media-sticky__stage">
        <canvas class="dm-mobile-media-sticky__canvas" aria-label="Customily personalization preview image"></canvas>
      </div>
      <button class="dm-mobile-media-sticky__close" type="button" aria-label="Close Customily preview">
        <img src="${getAssetUrl('icon-close.svg')}" alt="">
      </button>
      <div class="dm-mobile-media-sticky__zoom" aria-label="Preview zoom controls">
        <button type="button" aria-label="Zoom in" data-mobile-customily-zoom="in">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M11 5h2v6h6v2h-6v6h-2v-6H5v-2h6V5z" fill="currentColor"/></svg>
        </button>
        <button type="button" aria-label="Zoom out" data-mobile-customily-zoom="out" disabled>
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 11h14v2H5v-2z" fill="currentColor"/></svg>
        </button>
      </div>
    `;
    document.body.insertBefore(stickyPreview, document.body.firstChild);

    const restoreButton = document.createElement('button');
    restoreButton.type = 'button';
    restoreButton.className = 'dm-mobile-media-sticky__restore';
    restoreButton.setAttribute('aria-label', 'Show Customily preview');
    restoreButton.setAttribute('aria-hidden', 'true');
    restoreButton.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3.5" y="4.5" width="15" height="14" rx="1.5" fill="none" stroke="currentColor" stroke-width="1.4"/>
        <circle cx="14.5" cy="8.5" r="1.5" fill="none" stroke="currentColor" stroke-width="1.2"/>
        <path d="m5.5 16 4-4 3 3 2-2 2 2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M18.5 13.5v6m0 0-2-2m2 2 2-2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    `;
    document.body.insertBefore(restoreButton, stickyPreview.nextSibling);

    stickyPreview.querySelector('.dm-mobile-media-sticky__close')?.addEventListener('click', function (event) {
      const scrollYBeforeClose = zoomInteractionScrollY ?? window.scrollY;
      zoomInteractionScrollY = null;
      event.preventDefault();
      event.stopPropagation();
      manualRestoreActive = false;
      zoomInteractionActive = false;
      manualCloseActive = true;
      dismissed = true;
      setStickyVisible(false);
      setRestoreVisible(true);
      event.currentTarget.blur();
      restoreZoomScrollPosition(scrollYBeforeClose);
    });

    restoreButton.addEventListener('pointerdown', function (event) {
      restoreInteractionScrollY = window.scrollY;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    restoreButton.addEventListener('click', function (event) {
      const scrollYBeforeRestore = restoreInteractionScrollY ?? window.scrollY;
      restoreInteractionScrollY = null;
      event.preventDefault();
      event.stopPropagation();
      manualCloseActive = false;
      dismissed = false;
      manualRestoreActive = true;
      manualRestoreIgnoreScrollUntil = Date.now() + 700;
      setRestoreVisible(false);
      setStickyVisible(true);
      event.currentTarget.blur();
      restoreZoomScrollPosition(scrollYBeforeRestore);
    });

    stickyPreview.addEventListener('pointerdown', function (event) {
      if (!event.target.closest?.('[data-mobile-customily-zoom], .dm-mobile-media-sticky__close')) return;
      zoomInteractionScrollY = window.scrollY;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    stickyPreview.addEventListener('click', function (event) {
      const zoomButton = event.target.closest?.('[data-mobile-customily-zoom]');
      const action = zoomButton?.dataset.mobileCustomilyZoom;
      if (!action) return;

      const scrollYBeforeZoom = zoomInteractionScrollY ?? window.scrollY;
      zoomInteractionScrollY = null;
      event.preventDefault();
      event.stopPropagation();
      zoomInteractionActive = true;
      zoomInteractionIgnoreScrollUntil = Date.now() + 700;
      zoom = action === 'in' ? Math.min(2.5, zoom + 0.25) : Math.max(1, zoom - 0.25);
      if (zoom <= 1) {
        panX = 0;
        panY = 0;
      } else {
        clampPan();
      }
      applyStickyTransform();
      zoomButton.blur();
      restoreZoomScrollPosition(scrollYBeforeZoom);
    });

    const stage = stickyPreview.querySelector('.dm-mobile-media-sticky__stage');
    stage?.addEventListener('pointerdown', startPan);
    stage?.addEventListener('pointermove', movePan);
    stage?.addEventListener('pointerup', endPan);
    stage?.addEventListener('pointercancel', endPan);
    stage?.addEventListener('touchstart', startPinch, { passive: false });
    stage?.addEventListener('touchmove', movePinch, { passive: false });
    stage?.addEventListener('touchend', endPinch, { passive: false });
    stage?.addEventListener('touchcancel', endPinch, { passive: false });

    return stickyPreview;
  }

  function getRestoreButton() {
    return document.querySelector('.dm-mobile-media-sticky__restore');
  }

  function setRestoreVisible(visible) {
    const restoreButton = getRestoreButton();
    if (!restoreButton) return;
    restoreButton.classList.toggle('is-visible', visible);
    restoreButton.setAttribute('aria-hidden', String(!visible));
  }

  function restoreZoomScrollPosition(scrollY) {
    const restore = function () {
      if (Math.abs(window.scrollY - scrollY) > 1) window.scrollTo(0, scrollY);
      scheduleUpdate();
    };

    restore();
    window.requestAnimationFrame(restore);
    window.setTimeout(restore, 50);
  }

  function getPanBounds() {
    const rect = stickyPreview?.querySelector('.dm-mobile-media-sticky__stage')?.getBoundingClientRect();
    if (!rect || zoom <= 1) return { x: 0, y: 0 };
    return {
      x: (rect.width * (zoom - 1)) / 2,
      y: (rect.height * (zoom - 1)) / 2
    };
  }

  function clampPan() {
    const bounds = getPanBounds();
    panX = Math.max(-bounds.x, Math.min(bounds.x, panX));
    panY = Math.max(-bounds.y, Math.min(bounds.y, panY));
  }

  function applyStickyTransform() {
    const canvas = stickyPreview?.querySelector('.dm-mobile-media-sticky__canvas');
    if (canvas) {
      canvas.style.setProperty('--dm-mobile-customily-zoom', String(zoom));
      canvas.style.setProperty('--dm-mobile-customily-pan-x', `${panX}px`);
      canvas.style.setProperty('--dm-mobile-customily-pan-y', `${panY}px`);
    }

    const stage = stickyPreview?.querySelector('.dm-mobile-media-sticky__stage');
    stage?.classList.toggle('is-zoomed', zoom > 1);
    const zoomOut = stickyPreview?.querySelector('[data-mobile-customily-zoom="out"]');
    if (zoomOut) zoomOut.disabled = zoom <= 1;
  }

  function startPan(event) {
    if (zoom <= 1 || event.button !== 0) return;
    if (event.pointerType === 'touch' && !event.isPrimary) return;
    event.preventDefault();
    dragState = {
      pointerId: event.pointerId,
      startX: event.clientX,
      startY: event.clientY,
      originX: panX,
      originY: panY
    };
    event.currentTarget.classList.add('is-dragging');
    event.currentTarget.setPointerCapture?.(event.pointerId);
  }

  function movePan(event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;
    event.preventDefault();
    panX = dragState.originX + event.clientX - dragState.startX;
    panY = dragState.originY + event.clientY - dragState.startY;
    clampPan();
    applyStickyTransform();
  }

  function endPan(event) {
    if (!dragState || event.pointerId !== dragState.pointerId) return;
    event.currentTarget.releasePointerCapture?.(event.pointerId);
    event.currentTarget.classList.remove('is-dragging');
    dragState = null;
  }

  function getPinchMetrics(touches) {
    const first = touches[0];
    const second = touches[1];
    return {
      distance: Math.hypot(second.clientX - first.clientX, second.clientY - first.clientY),
      clientX: (first.clientX + second.clientX) / 2,
      clientY: (first.clientY + second.clientY) / 2
    };
  }

  function startPinch(event) {
    if (event.touches.length !== 2) return;
    event.preventDefault();

    const stage = event.currentTarget;
    if (dragState) {
      if (stage.hasPointerCapture?.(dragState.pointerId)) {
        stage.releasePointerCapture(dragState.pointerId);
      }
      stage.classList.remove('is-dragging');
      dragState = null;
    }

    const rect = stage.getBoundingClientRect();
    const metrics = getPinchMetrics(event.touches);
    pinchState = {
      startDistance: Math.max(1, metrics.distance),
      startZoom: zoom,
      startPanX: panX,
      startPanY: panY,
      startMidX: metrics.clientX - rect.left - rect.width / 2,
      startMidY: metrics.clientY - rect.top - rect.height / 2
    };
    stage.classList.add('is-pinching');
  }

  function movePinch(event) {
    if (!pinchState || event.touches.length !== 2) return;
    event.preventDefault();

    const stage = event.currentTarget;
    const rect = stage.getBoundingClientRect();
    const metrics = getPinchMetrics(event.touches);
    const nextZoom = Math.max(
      1,
      Math.min(2.5, pinchState.startZoom * (metrics.distance / pinchState.startDistance))
    );
    const midX = metrics.clientX - rect.left - rect.width / 2;
    const midY = metrics.clientY - rect.top - rect.height / 2;
    const contentX = (pinchState.startMidX - pinchState.startPanX) / pinchState.startZoom;
    const contentY = (pinchState.startMidY - pinchState.startPanY) / pinchState.startZoom;

    zoom = nextZoom;
    panX = midX - contentX * zoom;
    panY = midY - contentY * zoom;
    if (zoom <= 1) {
      panX = 0;
      panY = 0;
    } else {
      clampPan();
    }
    applyStickyTransform();
  }

  function endPinch(event) {
    if (!pinchState || event.touches.length >= 2) return;
    event.preventDefault();
    pinchState = null;
    event.currentTarget.classList.remove('is-pinching');
    if (zoom <= 1) {
      panX = 0;
      panY = 0;
    }
    clampPan();
    applyStickyTransform();
  }

  function resetStickyTransform() {
    zoom = 1;
    panX = 0;
    panY = 0;
    dragState = null;
    pinchState = null;
    applyStickyTransform();
  }

  function mirrorCustomilyPreview() {
    window.cancelAnimationFrame(mirrorFrame);
    mirrorFrame = 0;
    if (!customilySource || !stickyPreview?.classList.contains('is-visible')) return;

    const target = stickyPreview.querySelector('.dm-mobile-media-sticky__canvas');
    if (!target) return;

    const maxDimension = 900;
    const scale = Math.min(1, maxDimension / Math.max(customilySource.width, customilySource.height));
    const width = Math.max(1, Math.round(customilySource.width * scale));
    const height = Math.max(1, Math.round(customilySource.height * scale));
    if (target.width !== width || target.height !== height) {
      target.width = width;
      target.height = height;
    }

    const context = target.getContext('2d');
    context?.clearRect(0, 0, width, height);
    try {
      context?.drawImage(customilySource, 0, 0, width, height);
    } catch (error) {
      // Customily may replace its canvas during a render; the next frame retries with the new source.
    }
    mirrorFrame = window.requestAnimationFrame(mirrorCustomilyPreview);
  }

  function setStickyVisible(visible) {
    if (!stickyPreview) return;
    stickyPreview.classList.toggle('is-visible', visible);
    stickyPreview.setAttribute('aria-hidden', String(!visible));
    document.body.classList.toggle(OPEN_CLASS, visible);
    if (visible) setRestoreVisible(false);
    if (visible && !mirrorFrame) mirrorFrame = window.requestAnimationFrame(mirrorCustomilyPreview);
    if (!visible && mirrorFrame) {
      window.cancelAnimationFrame(mirrorFrame);
      mirrorFrame = 0;
    }
  }

  function syncCustomilySource() {
    if (!currentProduct) return;
    const preview = findCustomilyPreview();
    if (!preview) {
      customilySource = null;
      customilyPreviewBoundary = null;
      setStickyVisible(false);
      return;
    }

    if (customilySource !== preview.source) resetStickyTransform();
    customilySource = preview.source;
    customilyPreviewBoundary = preview.boundary;
    ensureStickyPreview();
  }

  function hasBlockingModal() {
    return MODAL_BODY_CLASSES.some((className) => document.body.classList.contains(className));
  }

  function findReviewsBoundary() {
    return document.querySelector(
      '.judge-reviews-section, #product-reviews-section, #judgeme_product_reviews, .jdgm-review-widget'
    );
  }

  function updateStickyState() {
    frame = 0;
    if (
      !window.matchMedia(MOBILE_MEDIA_QUERY).matches ||
      !currentProduct ||
      !customilySource ||
      !customilyPreviewBoundary ||
      !hasCustomilyActivity()
    ) {
      setStickyVisible(false);
      setRestoreVisible(false);
      return;
    }

    if (!reviewsBoundary?.isConnected) reviewsBoundary = findReviewsBoundary();

    const previewRect = customilyPreviewBoundary.getBoundingClientRect();
    const reviewsRect = reviewsBoundary?.getBoundingClientRect();

    if ((manualRestoreActive || zoomInteractionActive) && !hasBlockingModal()) {
      setStickyVisible(true);
      setRestoreVisible(false);
      return;
    }

    if (previewRect.bottom > 0 && !manualCloseActive) {
      dismissed = false;
      setRestoreVisible(false);
    }

    const previewHasPassed = previewRect.bottom <= 0;
    const reviewsHaveArrived = reviewsRect ? reviewsRect.top <= window.innerHeight : false;
    const canShowSticky = previewHasPassed && !reviewsHaveArrived && !hasBlockingModal();

    if (manualCloseActive) {
      setStickyVisible(false);
      setRestoreVisible(canShowSticky);
      return;
    }

    setStickyVisible(canShowSticky && !dismissed);
    setRestoreVisible(canShowSticky && dismissed);
  }

  function scheduleUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(updateStickyState);
  }

  function connectProduct() {
    const nextProduct = document.querySelector('product-info');
    if (!nextProduct) return;

    currentProduct = nextProduct;
    reviewsBoundary = findReviewsBoundary();
    syncCustomilySource();
    scheduleUpdate();

    observer?.disconnect();
    observer = new MutationObserver(function (mutations) {
      if (mutations.some((mutation) => mutation.type === 'childList' || mutation.attributeName === 'src' || mutation.attributeName === 'class')) {
        syncCustomilySource();
        scheduleUpdate();
      }
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['src', 'class'],
      childList: true,
      subtree: true
    });
  }

  window.addEventListener('scroll', function () {
    if (manualRestoreActive && Date.now() > manualRestoreIgnoreScrollUntil) {
      manualRestoreActive = false;
    }
    if (zoomInteractionActive && Date.now() > zoomInteractionIgnoreScrollUntil) {
      zoomInteractionActive = false;
    }
    scheduleUpdate();
  }, { passive: true });
  window.addEventListener('resize', function () {
    syncMobileVisualViewport();
    scheduleUpdate();
  }, { passive: true });
  window.visualViewport?.addEventListener('resize', syncMobileVisualViewport, { passive: true });
  window.visualViewport?.addEventListener('scroll', syncMobileVisualViewport, { passive: true });
  document.addEventListener('variant:change', function () {
    window.requestAnimationFrame(function () {
      syncCustomilySource();
      scheduleUpdate();
    });
  });
  document.addEventListener('DOMContentLoaded', connectProduct);
  window.addEventListener('load', connectProduct);
  syncMobileVisualViewport();
})();

(function () {
  const ROOT_SELECTOR = '#customily-options';
  const TRIGGER_CLASS = 'dm-photo-guidelines-trigger';
  const MODAL_ID = 'DmPhotoUploadGuidelines';
  const UPLOAD_PROCESSING_MODAL_ID = 'DmCustomilyUploadProcessingModal';
  const PHOTO_EDITOR_MODAL_ID = 'DmCustomilyPhotoEditorModal';
  const CONDITIONS_HIDDEN_CLASS = 'dm-customily-conditions-hidden';
  const PERSONALIZED_TITLE_CLASS = 'dm-customily-personalized-title';
  const PHOTO_UPLOAD_CLASS = 'dm-customily-photo-upload';
  const UPLOAD_LABEL_CLASS = 'dm-customily-upload-label';
  const UPLOAD_CONTROL_CLASS = 'dm-customily-select-image-control';
  const UPLOAD_WRAP_CLASS = 'dm-customily-upload-control-wrap';
  const UPLOAD_FIELD_CLASS = 'dm-customily-upload-field';
  const INLINE_GUIDELINES_CLASS = 'dm-customily-upload-guidelines';
  const UPLOAD_SUMMARY_CLASS = 'dm-customily-upload-summary';
  const UPLOAD_SUMMARY_THUMB_CLASS = 'dm-customily-upload-summary__thumb';
  const UPLOAD_SUMMARY_NAME_CLASS = 'dm-customily-upload-summary__name';
  const UPLOAD_ACTION_CLASS = 'dm-customily-upload-action';
  const UPLOAD_EDIT_ACTION_CLASS = 'dm-customily-upload-edit-action';
  const PROCESSING_MIN_VISIBLE_MS = 50000;
  const PROCESSING_INITIAL_PROGRESS = 0;
  const PROCESSING_PENDING_MAX_PROGRESS = 100;
  const PROCESSING_SETTLE_MS = 500;
  const PROCESSING_MAX_VISIBLE_MS = PROCESSING_MIN_VISIBLE_MS;
  let lastGuidelinesTrigger = null;
  let enhanceRaf = 0;
  let processingStartedAt = 0;
  let processingSettleTimer = 0;
  let processingMaxTimer = 0;
  let processingCheckTimer = 0;
  let processingProgressTimer = 0;
  let processingModalCloseTimer = 0;
  let processingStepAnimationTimer = 0;
  let uploadProcessingProgress = PROCESSING_INITIAL_PROGRESS;
  let uploadPickerExpectedUntil = 0;
  let processingInitialSignature = '';
  let activeUploadControl = null;
  let pendingPhotoEditorOpen = false;
  let photoEditorLastFocus = null;
  let photoEditorCanvasPlaceholder = null;
  let photoEditorCanvasWrapper = null;
  let photoEditorActionHistory = [];
  let photoEditorNativeControls = [];
  let photoEditorNativeControlHomes = [];
  let photoEditorInertElements = [];
  let photoEditorPinchState = null;
  let isRevertingPhotoEditor = false;
  let isDispatchingPhotoEditorAction = false;

  const PHOTO_ICON = `
    <svg viewBox="0 0 20 20" focusable="false" aria-hidden="true">
      <path fill="currentColor" d="M5.25 4.5h1.74l.72-1.08c.26-.39.7-.62 1.16-.62h2.26c.47 0 .9.23 1.16.62l.72 1.08h1.74A2.25 2.25 0 0 1 17 6.75v7.5a2.25 2.25 0 0 1-2.25 2.25h-9.5A2.25 2.25 0 0 1 3 14.25v-7.5A2.25 2.25 0 0 1 5.25 4.5Zm4.75 3a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5Zm0 1.3a1.95 1.95 0 1 1 0 3.9 1.95 1.95 0 0 1 0-3.9Z"/>
    </svg>
  `;

  const CLOSE_ICON = `
    <svg viewBox="0 0 18 18" focusable="false" aria-hidden="true">
      <path fill="currentColor" d="M3.22 2.16 9 7.94l5.78-5.78 1.06 1.06L10.06 9l5.78 5.78-1.06 1.06L9 10.06l-5.78 5.78-1.06-1.06L7.94 9 2.16 3.22l1.06-1.06Z"/>
    </svg>
  `;

  const PHOTO_EDITOR_CONTROL_MAP = {
    'move-up': { index: 0, inverse: 'move-down', clicks: 1 },
    'move-down': { index: 1, inverse: 'move-up', clicks: 1 },
    'move-left': { index: 2, inverse: 'move-right', clicks: 1 },
    'move-right': { index: 3, inverse: 'move-left', clicks: 1 },
    'rotate-left': { index: 4, inverse: 'rotate-right', clicks: 1 },
    'rotate-right': { index: 4, inverse: 'rotate-left', clicks: 3 },
    'zoom-in': { index: 5, inverse: 'zoom-out', clicks: 1 },
    'zoom-out': { index: 6, inverse: 'zoom-in', clicks: 1 }
  };

  const PROCESSING_BRAND_LOGO_FILENAME = 'dearmora-processing-logo.png';

  const PROCESSING_NOTE_SHIELD_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" focusable="false" aria-hidden="true">
      <path d="M256 45 L405 112 V250 C405 350 344 424 256 474 C168 424 107 350 107 250 V112 Z" stroke="#C79242" stroke-width="34" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M187 253 L235 301 L329 191" stroke="#C79242" stroke-width="36" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const PROCESSING_NOTE_TIMER_ICON = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" focusable="false" aria-hidden="true">
      <rect x="202" y="38" width="108" height="30" rx="15" fill="#C79242"/>
      <circle cx="256" cy="286" r="158" stroke="#C79242" stroke-width="36"/>
      <path d="M256 286 V190" stroke="#C79242" stroke-width="36" stroke-linecap="round"/>
      <path d="M256 286 L335 329" stroke="#C79242" stroke-width="36" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  const UPLOAD_PROCESSING_STEPS = [
    {
      step: 1,
      start: 0,
      end: 25,
      title: 'Analyzing your photo',
      description: "We're carefully reviewing the details that make your photo unique.",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" focusable="false" aria-hidden="true"><circle cx="256" cy="256" r="224" stroke="#EEE6DB" stroke-width="28"/><circle cx="256" cy="256" r="194" stroke="#F5F0E9" stroke-width="10"/><circle cx="235" cy="235" r="78" stroke="#C79242" stroke-width="24"/><path d="M292 292 L362 362" stroke="#C79242" stroke-width="24" stroke-linecap="round"/><path d="M235 192 L245 216 L269 226 L245 236 L235 260 L225 236 L201 226 L225 216 Z" fill="#C79242"/></svg>'
    },
    {
      step: 2,
      start: 25,
      end: 50,
      title: 'Applying your chosen art style',
      description: "We're applying your chosen style to your photo.",
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" focusable="false" aria-hidden="true"><circle cx="256" cy="256" r="224" stroke="#EEE6DB" stroke-width="28"/><circle cx="256" cy="256" r="194" stroke="#F5F0E9" stroke-width="10"/><path d="M173 339 L339 173" stroke="#C79242" stroke-width="24" stroke-linecap="round"/><rect x="162" y="323" width="65" height="28" rx="10" transform="rotate(-45 162 323)" fill="#C79242"/><path d="M340 123 L351 150 L378 161 L351 172 L340 199 L329 172 L302 161 L329 150 Z" fill="#C79242"/><path d="M387 197 L394 215 L412 222 L394 229 L387 247 L380 229 L362 222 L380 215 Z" fill="#C79242"/><path d="M250 120 L257 138 L275 145 L257 152 L250 170 L243 152 L225 145 L243 138 Z" fill="#C79242"/></svg>'
    },
    {
      step: 3,
      start: 50,
      end: 75,
      title: 'Creating your personalized preview',
      description: 'Your personalized preview is coming together.',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" focusable="false" aria-hidden="true"><circle cx="256" cy="256" r="224" stroke="#EEE6DB" stroke-width="28"/><circle cx="256" cy="256" r="194" stroke="#F5F0E9" stroke-width="10"/><rect x="145" y="145" width="222" height="184" rx="8" stroke="#C79242" stroke-width="24"/><rect x="169" y="169" width="174" height="136" rx="6" stroke="#C79242" stroke-width="14" opacity="0.55"/><circle cx="294" cy="201" r="17" fill="#C79242"/><path d="M177 288 L221 233 L259 270 L297 225 L335 288 Z" fill="#C79242"/></svg>'
    },
    {
      step: 4,
      start: 75,
      end: 100,
      title: 'Adding the final touches',
      description: 'Your preview is almost ready.',
      icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="none" focusable="false" aria-hidden="true"><circle cx="256" cy="256" r="224" stroke="#EEE6DB" stroke-width="28"/><circle cx="256" cy="256" r="194" stroke="#F5F0E9" stroke-width="10"/><path d="M256 368 C173 308 153 256 153 214 C153 176 182 146 219 146 C241 146 259 157 271 176 C283 157 301 146 323 146 C360 146 389 176 389 214 C389 256 369 308 286 368 C274 376 269 380 256 368 Z" stroke="#C79242" stroke-width="18" stroke-linecap="round" stroke-linejoin="round"/><path d="M374 144 L383 166 L405 175 L383 184 L374 206 L365 184 L343 175 L365 166 Z" fill="#C79242"/></svg>'
    }
  ];

  const TOOL_ICONS = [
    '<svg viewBox="0 0 34 34" aria-hidden="true"><circle cx="15" cy="15" r="10"/><path d="m23 23 7 7M9 15h12"/></svg>',
    '<svg viewBox="0 0 34 34" aria-hidden="true"><circle cx="15" cy="15" r="10"/><path d="m23 23 7 7M15 9v12M9 15h12"/></svg>',
    '<svg viewBox="0 0 34 34" aria-hidden="true"><path d="M8 9v8h8"/><path d="M8 17a10 10 0 1 0 3-7.1"/></svg>',
    '<svg viewBox="0 0 34 34" aria-hidden="true"><path d="M6 17h22M20 9l8 8-8 8"/></svg>',
    '<svg viewBox="0 0 34 34" aria-hidden="true"><path d="M28 17H6M14 9l-8 8 8 8"/></svg>',
    '<svg viewBox="0 0 34 34" aria-hidden="true"><path d="M17 6v22M9 20l8 8 8-8"/></svg>',
    '<svg viewBox="0 0 34 34" aria-hidden="true"><path d="M17 28V6M9 14l8-8 8 8"/></svg>'
  ];

  function customilyRootHasPhotoUpload(root) {
    const text = root.textContent.replace(/\s+/g, ' ').toLowerCase();
    return (
      text.includes('upload your photo') ||
      text.includes('select image') ||
      text.includes('choose and upload your photo') ||
      Boolean(root.querySelector('input[type="file"]'))
    );
  }

  function getGuidelinesInsertTarget(root) {
    const candidates = Array.from(root.querySelectorAll('h1, h2, h3, .title, .heading, [class*="title"], [class*="heading"]'));
    return candidates.find((element) => /personalized|personalised/i.test(element.textContent || '')) || null;
  }

  function isVisibleCustomilyNode(element) {
    if (!element) return false;
    if (
      element.closest(
        `.${PERSONALIZED_TITLE_CLASS}, .${TRIGGER_CLASS}, .${INLINE_GUIDELINES_CLASS}, .${UPLOAD_SUMMARY_CLASS}, .dm-customily-required-message`
      )
    ) {
      return false;
    }

    const style = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  }

  function customilyRootHasVisibleConditionContent(root) {
    const candidates = Array.from(
      root.querySelectorAll(
        [
          'input:not([type="hidden"])',
          'textarea',
          'select',
          'button',
          '[role="button"]',
          '[role="radio"]',
          '[role="checkbox"]',
          'label',
          '.customily-option-label',
          '.customily_label',
          '.option-label',
          '.form__label',
          '.customily-option',
          '.customily_option',
          '.customily-section',
          '.customily_section',
          '.cl_option',
          'img',
          'picture',
          'canvas'
        ].join(',')
      )
    );

    return candidates.some((element) => {
      if (!isVisibleCustomilyNode(element)) return false;
      if (element.classList.contains(TRIGGER_CLASS)) return false;
      if (element.matches('button, input, textarea, select') && element.disabled) return false;

      if (element.matches('label, .customily-option-label, .customily_label, .option-label, .form__label')) {
        return element.textContent.replace(/\*/g, '').trim().length > 0 || Boolean(element.querySelector('input, textarea, select, button, img, picture, canvas'));
      }

      return true;
    });
  }

  function getCustomilyOptionWrapper(element) {
    return (
      element?.closest?.(
        '.customily-option, .customily_option, .customily-option-container, .customily_option_container, .customily-section, .customily_section, .customily-field, .customily_input, .form-group, .cl_option, li'
      ) ||
      element?.parentElement ||
      null
    );
  }

  function getPhotoUploadLabel(root) {
    return Array.from(root.querySelectorAll('label, .customily-option-label, .customily_label, .option-label, .form__label, [class*="label"]')).find(
      (element) => /upload\s+(your\s+)?photo/i.test(element.textContent || '')
    );
  }

  function getPhotoUploadLabels(root) {
    return Array.from(root.querySelectorAll('label, .customily-option-label, .customily_label, .option-label, .form__label, [class*="label"]')).filter(
      (element) => /upload\s+(your\s+)?photo/i.test(element.textContent || '')
    );
  }

  function getSelectImageControl(root) {
    return Array.from(root.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"], label')).find((element) => {
      if (element.classList.contains(TRIGGER_CLASS)) return false;
      if (element.classList.contains(UPLOAD_ACTION_CLASS)) return false;
      if (element.classList.contains(UPLOAD_EDIT_ACTION_CLASS)) return false;

      const text = `${element.textContent || ''} ${element.value || ''} ${element.getAttribute('aria-label') || ''}`;
      return /select\s+image|choose\s+image|replace|edit/i.test(text);
    });
  }

  function getSelectImageControls(root) {
    return Array.from(root.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"], label')).filter((element) => {
      if (element.classList.contains(TRIGGER_CLASS)) return false;
      if (element.classList.contains(UPLOAD_ACTION_CLASS)) return false;
      if (element.classList.contains(UPLOAD_EDIT_ACTION_CLASS)) return false;

      const text = `${element.textContent || ''} ${element.value || ''} ${element.getAttribute('aria-label') || ''}`;
      return /select\s+image|choose\s+image|replace|edit/i.test(text);
    });
  }

  function triggerUploadControlFromWrapper(wrapper, event) {
    if (!wrapper || !wrapper.classList.contains(UPLOAD_WRAP_CLASS)) return false;
    if (event.target.closest(`.${UPLOAD_CONTROL_CLASS}, .${UPLOAD_ACTION_CLASS}`)) return false;
    if (event.target.closest('input, textarea, select, a, button')) return false;

    const control = wrapper.querySelector(`.${UPLOAD_CONTROL_CLASS}`);
    if (!control) return false;

    event.preventDefault();
    uploadPickerExpectedUntil = Date.now() + 12000;
    activeUploadControl = control;
    control.click();
    return true;
  }

  function triggerUploadControl(root, control, event) {
    if (!root) return false;

    const targetControl =
      control ||
      root.querySelector(`.${UPLOAD_CONTROL_CLASS}`) ||
      getSelectImageControl(root) ||
      root.querySelector('input[type="file"]');

    if (!targetControl) return false;

    event?.preventDefault?.();
    uploadPickerExpectedUntil = Date.now() + 12000;
    activeUploadControl = event?.currentTarget instanceof Element ? event.currentTarget : targetControl;

    if (activeUploadControl !== targetControl) {
      targetControl._dmSuppressUploadClick = true;
    }

    targetControl.click();
    return true;
  }

  function normalizeUploadLabelElement(label) {
    if (!label) return null;

    label.classList.add(UPLOAD_LABEL_CLASS);
    return label;
  }

  function normalizeUploadLabel(root) {
    return normalizeUploadLabelElement(getPhotoUploadLabel(root));
  }

  function getUploadLabelFromWrapper(uploadWrapper) {
    if (!uploadWrapper) return null;

    return Array.from(uploadWrapper.children).find((element) => {
      return (
        element.matches('label, [role="button"], .customily-option-label, .customily_label, .option-label, .form__label') &&
        element.querySelector('.option_name, .customily-required-label')
      );
    }) || null;
  }

  function ensurePersonalizedTitle(root) {
    if (root.querySelector(`.${PERSONALIZED_TITLE_CLASS}`)) return;

    const title = document.createElement('h2');
    title.className = PERSONALIZED_TITLE_CLASS;
    title.textContent = 'PERSONALIZED';
    root.insertBefore(title, root.firstChild);
  }

  function ensureInlineGuidelines(root, uploadWrapper) {
    if (root.querySelector(`.${INLINE_GUIDELINES_CLASS}`)) return;

    const existingText = root.textContent.replace(/\s+/g, ' ');
    if (/CROP the image before uploading/i.test(existingText)) return;

    const guidelines = document.createElement('div');
    guidelines.className = INLINE_GUIDELINES_CLASS;
    guidelines.innerHTML = `
      <p>1 - CROP the image before uploading that will get you a better result. Photo with large pixels and a high resolution is highly recommended.</p>
      <p>2 - Click the SELECT IMAGE button to upload your photo or re-upload another one.</p>
      <p>3 - Adjust the photo position (change, rotate, zoom out/in, move up/down/right/left) at the function buttons below the preview.</p>
      <p>4 - Please wait 20 - 30 seconds for result.</p>
    `;

    if (uploadWrapper?.isConnected) {
      uploadWrapper.insertAdjacentElement('afterend', guidelines);
    } else {
      root.appendChild(guidelines);
    }
  }

  function extractUploadedPhotoName(root) {
    const text = root.textContent.replace(/\s+/g, ' ');
    return text.match(/[a-z0-9-]{8,}[-_ ]*CUSTOMILYT?E?\.{0,3}/i)?.[0] || null;
  }

  function getUploadedPhotoName(root) {
    const summary = root.querySelector(`.${UPLOAD_SUMMARY_NAME_CLASS}`);
    const match = extractUploadedPhotoName(root);

    return (match || summary?.textContent || 'CUSTOMILYT...').replace(/\s+/g, '').replace(/CUSTOMILYTE/i, 'CUSTOMILYT').trim();
  }

  function getUploadWrapperMedia(uploadWrapper, selector) {
    if (!uploadWrapper) return null;

    return Array.from(uploadWrapper.querySelectorAll(selector)).find((element) => !element.closest(`.${UPLOAD_SUMMARY_CLASS}`)) || null;
  }

  function getUploadField(uploadWrapper) {
    if (!uploadWrapper) return null;

    return (
      uploadWrapper.querySelector(':scope > [role="region"], :scope > [id*="option-accordion"], :scope > .customily-file-input, :scope > .customily_file_input') ||
      uploadWrapper
    );
  }

  function getPhotoUploadWrapper(root, uploadLabel, selectControl) {
    if (!selectControl) return uploadLabel ? getCustomilyOptionWrapper(uploadLabel) : null;

    const labelWrapper = uploadLabel ? getCustomilyOptionWrapper(uploadLabel) : null;
    if (labelWrapper && labelWrapper !== root && labelWrapper.contains(selectControl)) return labelWrapper;

    const optionWrapper = getCustomilyOptionWrapper(selectControl);
    if (optionWrapper && optionWrapper !== root) return optionWrapper;

    return selectControl.parentElement && selectControl.parentElement !== root ? selectControl.parentElement : optionWrapper;
  }

  function createUploadThumbnail(root, uploadWrapper) {
    const source =
      getUploadWrapperMedia(uploadWrapper, 'img, picture img') ||
      root.querySelector('.cl-container img, .canvas-wrapper img, .canvas-container img, .customily-uploaded-image img, [class*="uploaded"] img');
    const canvas =
      getUploadWrapperMedia(uploadWrapper, 'canvas') ||
      root.querySelector('.cl-container canvas, .canvas-wrapper canvas, .canvas-container canvas');
    const thumb = document.createElement('span');
    thumb.className = UPLOAD_SUMMARY_THUMB_CLASS;

    if (source) {
      const image = source.cloneNode(false);
      image.removeAttribute('width');
      image.removeAttribute('height');
      thumb.appendChild(image);
      return thumb;
    }

    if (canvas instanceof HTMLCanvasElement) {
      try {
        const image = document.createElement('img');
        image.src = canvas.toDataURL('image/png');
        thumb.appendChild(image);
        return thumb;
      } catch (error) {
        // Fall back to the upload icon if the canvas is not readable.
      }
    }

    thumb.innerHTML = PHOTO_ICON;
    return thumb;
  }

  function ensureUploadSummary(root, uploadWrapper) {
    const uploadField = getUploadField(uploadWrapper);
    if (!uploadField) return;

    let summary = uploadField.querySelector(`.${UPLOAD_SUMMARY_CLASS}`);

    if (!summary) {
      summary = document.createElement('div');
      summary.className = UPLOAD_SUMMARY_CLASS;
      uploadField.insertBefore(summary, uploadField.firstChild);
    }

    summary.replaceChildren(createUploadThumbnail(root, uploadWrapper));

    const name = document.createElement('span');
    name.className = UPLOAD_SUMMARY_NAME_CLASS;
    name.textContent = 'Upload photo successfully!';
    summary.appendChild(name);
  }

  function ensureUploadAction(root, uploadWrapper, selectControl, hasUploadedFile) {
    const uploadField = getUploadField(uploadWrapper);
    if (!uploadField) return;

    let action = uploadField.querySelector(`.${UPLOAD_ACTION_CLASS}`);

    if (!action) {
      action = document.createElement('button');
      action.type = 'button';
      action.className = UPLOAD_ACTION_CLASS;
      uploadField.appendChild(action);
    }

    action.textContent = hasUploadedFile ? 'Replace' : 'SELECT IMAGE';
    action.setAttribute('aria-label', hasUploadedFile ? 'Replace image' : 'Select image');
    action._dmUploadControl = selectControl || root.querySelector(`.${UPLOAD_CONTROL_CLASS}`) || root.querySelector('input[type="file"]') || null;

    let editAction = uploadField.querySelector(`.${UPLOAD_EDIT_ACTION_CLASS}`);
    if (!hasUploadedFile) {
      editAction?.remove();
      return;
    }

    if (!editAction) {
      editAction = document.createElement('button');
      editAction.type = 'button';
      editAction.className = UPLOAD_EDIT_ACTION_CLASS;
      editAction.textContent = 'Edit';
      editAction.setAttribute('aria-label', 'Edit uploaded image');
      uploadField.insertBefore(editAction, action);
    }
  }

  function syncUploadedPhotoState(root, uploadWrapper, selectControl) {
    if (!uploadWrapper) return false;

    const hasUploadedName = Boolean(extractUploadedPhotoName(uploadWrapper));
    const hasUploadedPreview = Boolean(
      getUploadWrapperMedia(uploadWrapper, 'img, canvas, picture') ||
        uploadWrapper.querySelector('.cl-container img, .cl-container canvas, .customily-uploaded-image img, [class*="uploaded"] img, [class*="uploaded"] canvas')
    );
    const hasUploadedFile = hasUploadedName || hasUploadedPreview;

    uploadWrapper.classList.toggle('dm-customily-upload-control-wrap--has-file', hasUploadedFile);
    if (hasUploadedFile) {
      ensureUploadSummary(root, uploadWrapper);
    } else {
      uploadWrapper.querySelector(`.${UPLOAD_SUMMARY_CLASS}`)?.remove();
    }

    ensureUploadAction(root, uploadWrapper, selectControl, hasUploadedFile);

    uploadWrapper.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"]').forEach((button) => {
      const buttonText = `${button.textContent || ''} ${button.value || ''} ${button.getAttribute('aria-label') || ''}`.trim();
      button.classList.toggle('dm-customily-upload-remove-control', hasUploadedFile && /^[x×✕✖]$/i.test(buttonText));
    });

    return hasUploadedFile;
  }

  function normalizePhotoUploadLayout(root) {
    root.classList.add(PHOTO_UPLOAD_CLASS);
    ensurePersonalizedTitle(root);

    const uploadLabels = getPhotoUploadLabels(root).map(normalizeUploadLabelElement).filter(Boolean);
    const selectControls = getSelectImageControls(root);
    const uploadItems = [];
    const uploadWrappers = new Set();
    const uploadFields = new Set();

    selectControls.forEach((selectControl) => {
      selectControl.classList.add(UPLOAD_CONTROL_CLASS);
      if (processingStartedAt) setUploadButtonLoading(selectControl);

      const uploadLabel =
        uploadLabels.find((label) => getCustomilyOptionWrapper(label)?.contains(selectControl)) ||
        normalizeUploadLabelElement(getUploadLabelFromWrapper(getCustomilyOptionWrapper(selectControl)));
      const uploadWrapper = getPhotoUploadWrapper(root, uploadLabel, selectControl);
      const uploadField = getUploadField(uploadWrapper);

      if (!uploadWrapper || !uploadField || uploadWrappers.has(uploadWrapper)) return;

      uploadItems.push({ uploadLabel, selectControl, uploadWrapper, uploadField });
      uploadWrappers.add(uploadWrapper);
      uploadFields.add(uploadField);
    });

    uploadLabels.forEach((uploadLabel) => {
      const uploadWrapper = getCustomilyOptionWrapper(uploadLabel);
      const uploadField = getUploadField(uploadWrapper);
      if (!uploadWrapper || !uploadField || uploadWrappers.has(uploadWrapper)) return;

      uploadItems.push({
        uploadLabel,
        selectControl: uploadWrapper.querySelector(`.${UPLOAD_CONTROL_CLASS}`) || getSelectImageControl(uploadWrapper),
        uploadWrapper,
        uploadField
      });
      uploadWrappers.add(uploadWrapper);
      uploadFields.add(uploadField);
    });

    root.querySelectorAll(`.${UPLOAD_WRAP_CLASS}`).forEach((element) => {
      if (!uploadWrappers.has(element)) element.classList.remove(UPLOAD_WRAP_CLASS, 'dm-customily-upload-control-wrap--has-file');
    });
    root.querySelectorAll(`.${UPLOAD_FIELD_CLASS}`).forEach((element) => {
      if (!uploadFields.has(element)) element.classList.remove(UPLOAD_FIELD_CLASS);
    });

    let hasAnyUploadedFile = false;
    let firstUploadWrapper = null;

    uploadItems.forEach(({ uploadWrapper, uploadField, selectControl }) => {
      firstUploadWrapper ||= uploadWrapper;
      uploadWrapper.classList.add(UPLOAD_WRAP_CLASS);
      uploadField.classList.add(UPLOAD_FIELD_CLASS);
      hasAnyUploadedFile = syncUploadedPhotoState(root, uploadWrapper, selectControl) || hasAnyUploadedFile;
    });

    root.classList.toggle('dm-customily-upload-has-file', hasAnyUploadedFile);
    ensureInlineGuidelines(root, firstUploadWrapper);
  }

  function resetPhotoUploadLayout(root) {
    root.classList.remove(PHOTO_UPLOAD_CLASS, 'dm-customily-upload-has-file');
    root.querySelector(`.${PERSONALIZED_TITLE_CLASS}`)?.remove();
    root.querySelector(`.${INLINE_GUIDELINES_CLASS}`)?.remove();
    root.querySelectorAll(`.${UPLOAD_ACTION_CLASS}, .${UPLOAD_SUMMARY_CLASS}`).forEach((element) => element.remove());
    root.querySelectorAll(`.${UPLOAD_LABEL_CLASS}, .${UPLOAD_CONTROL_CLASS}, .${UPLOAD_WRAP_CLASS}, .${UPLOAD_FIELD_CLASS}`).forEach((element) => {
      element.classList.remove(UPLOAD_LABEL_CLASS, UPLOAD_CONTROL_CLASS, UPLOAD_WRAP_CLASS, UPLOAD_FIELD_CLASS);
    });
  }

  function createGuidelinesTrigger() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = TRIGGER_CLASS;
    button.setAttribute('aria-haspopup', 'dialog');
    button.setAttribute('aria-controls', MODAL_ID);
    button.innerHTML = `<span class="dm-photo-guidelines-trigger__icon">${PHOTO_ICON}</span><span>View photo upload guidelines here</span>`;
    return button;
  }

  function ensureGuidelinesModal() {
    let modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'dm-photo-guidelines-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-labelledby', `${MODAL_ID}-Title`);
    modal.innerHTML = `
      <div class="dm-photo-guidelines-modal__overlay" data-photo-guidelines-close></div>
      <div class="dm-photo-guidelines-modal__dialog" role="document" tabindex="-1">
        <button type="button" class="dm-photo-guidelines-modal__close" data-photo-guidelines-close aria-label="Close photo upload guidelines">
          ${CLOSE_ICON}
        </button>
        <h2 id="${MODAL_ID}-Title">Photo Upload Guidelines</h2>
        <div class="dm-photo-guidelines-modal__content">
          <p>1 - <strong>CROP</strong> the image before uploading that will get you a better result. Photo with large pixels and a high resolution is highly recommended.</p>
          <p>2 - Click the <strong>SELECT IMAGE</strong> button to upload your photo or re-upload another one.</p>
          <p>3 - Adjust the position or zoom level of the image, then click on the <strong>"PREVIEW"</strong> button.</p>
          <div class="dm-photo-guidelines-modal__tools">${TOOL_ICONS.map((icon) => `<span>${icon}</span>`).join('')}</div>
          <p>4 - Please wait 20 - 30 seconds if using the Removed Background function.</p>
          <p>If the photo can't be uploaded, please feel free to checkout as usual then send us your order number and photo via <a href="/pages/contact" target="_blank" rel="noopener">Contact Us</a>. Once done, your order will be manually processed.</p>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    return modal;
  }

  function tickProcessingCompletionCheck() {
    window.clearTimeout(processingCheckTimer);
    if (!processingStartedAt) return;

    scheduleProcessingDone();
    processingCheckTimer = window.setTimeout(tickProcessingCompletionCheck, 900);
  }

  function getProcessingTargetSignature() {
    const root = document.querySelector('#customily-options');
    const targets = Array.from(
      document.querySelectorAll('#pwzrswiper-container-wrapper img, #pwzrswiper-container-wrapper canvas, .rio-media-gallery img, .rio-media-gallery canvas, .cl-canvas-container img, .cl-canvas-container canvas')
    );

    return [
      root?.textContent?.replace(/\s+/g, ' ').trim().slice(0, 400) || '',
      ...targets.map((element) => {
        if (element instanceof HTMLImageElement) return `img:${element.currentSrc || element.src || ''}:${element.naturalWidth}x${element.naturalHeight}`;
        if (element instanceof HTMLCanvasElement) return `canvas:${element.width}x${element.height}:${element.className || ''}`;
        return `${element.tagName}:${element.className || ''}`;
      })
    ].join('|');
  }

  function getThemeAssetUrl(filename) {
    const encodedFilename = encodeURIComponent(filename);
    const script = Array.from(document.scripts).find((element) => /\/assets\/[^/?#]+\.js(?:[?#].*)?$/.test(element.src));

    if (script?.src) {
      return script.src.replace(/\/assets\/[^/?#]+\.js(?:[?#].*)?$/, `/assets/${encodedFilename}`);
    }

    return `/cdn/shop/t/11/assets/${encodedFilename}`;
  }

  function applyUploadProcessingModalFonts(modal) {
    if (!modal) return;

    

    const headline = modal.querySelector('.dm-customily-upload-processing-modal__headline');
    headline?.style.setProperty('font-family', '"DM UTM Avo", Arial, sans-serif', 'important');
    headline?.style.setProperty('font-weight', '500', 'important');

    const headlineAccent = modal.querySelector('.dm-customily-upload-processing-modal__headline span');
    headlineAccent?.style.setProperty('font-family', '"DM UTM Avo", Arial, sans-serif', 'important');
    headlineAccent?.style.setProperty('font-weight', '500', 'important');
  }

  function ensureUploadProcessingModal() {
    let modal = document.getElementById(UPLOAD_PROCESSING_MODAL_ID);
    if (modal) {
      applyUploadProcessingModalFonts(modal);
      return modal;
    }

    modal = document.createElement('div');
    modal.id = UPLOAD_PROCESSING_MODAL_ID;
    modal.className = 'dm-customily-upload-processing-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('role', 'status');
    modal.setAttribute('aria-live', 'polite');
    modal.innerHTML = `
      <div class="dm-customily-upload-processing-modal__overlay"></div>
      <div class="dm-customily-upload-processing-modal__dialog">
        <div class="dm-customily-upload-processing-modal__content">
          <div class="dm-customily-upload-processing-modal__brand" aria-hidden="true">
            <img class="dm-customily-upload-processing-modal__brand-logo" src="${getThemeAssetUrl(PROCESSING_BRAND_LOGO_FILENAME)}" alt="" loading="eager">
          </div>
          <h2 class="dm-customily-upload-processing-modal__headline">Creating your <span>personalized preview</span></h2>
          <div class="dm-customily-upload-processing-modal__step-row">
            <span></span>
            <strong data-upload-processing-step>Step 1 of 4</strong>
            <span></span>
          </div>
          <div class="dm-customily-upload-processing-modal__visual" aria-hidden="true">
            <i class="dm-customily-upload-processing-modal__sparkle dm-customily-upload-processing-modal__sparkle--left">✦</i>
            <span class="dm-customily-upload-processing-modal__icon" data-upload-processing-icon></span>
            <i class="dm-customily-upload-processing-modal__sparkle dm-customily-upload-processing-modal__sparkle--right">✦</i>
          </div>
          <h3 data-upload-processing-title>Analyzing your photo</h3>
          <p class="dm-customily-upload-processing-modal__description" data-upload-processing-description>We're carefully reviewing the details that make your photo unique.</p>
          <div class="dm-customily-upload-processing-modal__progress" aria-hidden="true">
            <span data-upload-processing-bar></span>
            <ol class="dm-customily-upload-processing-modal__progress-steps">
              <li data-upload-processing-marker="1">1</li>
              <li data-upload-processing-marker="2">2</li>
              <li data-upload-processing-marker="3">3</li>
              <li data-upload-processing-marker="4">4</li>
            </ol>
            <b class="dm-customily-upload-processing-modal__progress-status" data-upload-processing-status>0%</b>
          </div>
          <div class="dm-customily-upload-processing-modal__notes">
            <p><span>${PROCESSING_NOTE_SHIELD_ICON}</span>Your photo is used only to create this preview.</p>
            <p><span>${PROCESSING_NOTE_TIMER_ICON}</span>This usually takes 30-60 seconds.</p>
          </div>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    applyUploadProcessingModalFonts(modal);
    setUploadProcessingProgress(uploadProcessingProgress);

    return modal;
  }

  function ensurePhotoEditorModal() {
    let modal = document.getElementById(PHOTO_EDITOR_MODAL_ID);
    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = PHOTO_EDITOR_MODAL_ID;
    modal.className = 'dm-customily-photo-editor';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('aria-label', 'Adjust your uploaded photo');
    modal.innerHTML = `
      <div class="dm-customily-photo-editor__overlay" data-photo-editor-close></div>
      <div class="dm-customily-photo-editor__dialog" role="document" tabindex="-1">
        <button type="button" class="dm-customily-photo-editor__close" data-photo-editor-close aria-label="Close photo editor">
          <img src="${getThemeAssetUrl('icon-close.svg')}" alt="">
        </button>
        <div class="dm-customily-photo-editor__preview" data-photo-editor-preview></div>
        <div class="dm-customily-photo-editor__controls" aria-label="Photo position controls"></div>
        <button type="button" class="dm-customily-photo-editor__replace" data-photo-editor-replace>Replace Photo</button>
        <div class="dm-customily-photo-editor__footer">
          <button type="button" class="dm-customily-photo-editor__cancel" data-photo-editor-close>Cancel</button>
          <button type="button" class="dm-customily-photo-editor__apply" data-photo-editor-apply>Apply</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    const preview = modal.querySelector('[data-photo-editor-preview]');
    preview?.addEventListener('touchstart', startPhotoEditorPinch, { passive: false });
    preview?.addEventListener('touchmove', movePhotoEditorPinch, { passive: false });
    preview?.addEventListener('touchend', endPhotoEditorPinch, { passive: false });
    preview?.addEventListener('touchcancel', endPhotoEditorPinch, { passive: false });
    return modal;
  }

  function getPhotoEditorCanvasWrapper() {
    return (
      document.querySelector('.cl-canvas-container .canvas-wrapper') ||
      document.querySelector('.canvas-wrapper:has(#preview-canvas)') ||
      document.querySelector('#preview-canvas')?.closest('.canvas-wrapper') ||
      null
    );
  }

  function getNativePhotoControls() {
    if (photoEditorNativeControls.length) return photoEditorNativeControls;

    const scope = photoEditorCanvasWrapper || getPhotoEditorCanvasWrapper();
    return Array.from(scope?.querySelectorAll('.customily-mobile-controls .cl-mobile-control-wrapper') || []);
  }

  function getNativePhotoControlClickTarget(control) {
    return control?.querySelector('.customily-mobile-controls-item') || control || null;
  }

  function setOrRemoveAttribute(element, name, value) {
    if (value === null) element.removeAttribute(name);
    else element.setAttribute(name, value);
  }

  function setPhotoEditorBackgroundInert(isInert) {
    const modal = document.getElementById(PHOTO_EDITOR_MODAL_ID);

    if (!isInert) {
      photoEditorInertElements.forEach(({ element, inert, ariaHidden }) => {
        if (!element.isConnected) return;
        element.inert = inert;
        setOrRemoveAttribute(element, 'aria-hidden', ariaHidden);
      });
      photoEditorInertElements = [];
      return;
    }

    if (!modal || photoEditorInertElements.length) return;

    photoEditorInertElements = Array.from(document.body.children)
      .filter((element) => element !== modal && element instanceof HTMLElement)
      .map((element) => {
        const state = {
          element,
          inert: element.inert,
          ariaHidden: element.getAttribute('aria-hidden')
        };
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
        return state;
      });
  }

  function mountNativePhotoControls(modal) {
    const nativeControls = getNativePhotoControls();
    if (nativeControls.length < 7) return false;

    const controlsContainer = modal.querySelector('.dm-customily-photo-editor__controls');
    if (!controlsContainer) return false;

    const actions = ['zoom-out', 'zoom-in', 'rotate-left', 'move-left', 'move-right', 'move-up', 'move-down'];
    const labels = {
      'zoom-out': 'Zoom out',
      'zoom-in': 'Zoom in',
      'rotate-left': 'Rotate left',
      'move-left': 'Move left',
      'move-right': 'Move right',
      'move-up': 'Move up',
      'move-down': 'Move down'
    };

    controlsContainer.replaceChildren();
    photoEditorNativeControls = nativeControls;
    photoEditorNativeControlHomes = [];

    actions.forEach((action) => {
      const controlConfig = PHOTO_EDITOR_CONTROL_MAP[action];
      const nativeControl = nativeControls[controlConfig.index];

      const placeholder = document.createComment(`dm-customily-native-control-${action}`);
      const home = {
        control: nativeControl,
        placeholder,
        role: nativeControl.getAttribute('role'),
        tabindex: nativeControl.getAttribute('tabindex'),
        ariaLabel: nativeControl.getAttribute('aria-label')
      };
      nativeControl.parentNode.insertBefore(placeholder, nativeControl);
      nativeControl.classList.add('dm-customily-photo-editor__native-control');
      nativeControl.dataset.photoEditorNativeAction = action;
      nativeControl.setAttribute('role', 'button');
      nativeControl.setAttribute('tabindex', '0');
      nativeControl.setAttribute('aria-label', labels[action]);
      controlsContainer.appendChild(nativeControl);
      photoEditorNativeControlHomes.push(home);
    });

    return true;
  }

  function restoreNativePhotoControls() {
    photoEditorNativeControlHomes.forEach(({ control, placeholder, role, tabindex, ariaLabel }) => {
      if (placeholder.parentNode) {
        placeholder.parentNode.insertBefore(control, placeholder);
        placeholder.remove();
      }
      control.classList.remove('dm-customily-photo-editor__native-control');
      delete control.dataset.photoEditorNativeAction;
      setOrRemoveAttribute(control, 'role', role);
      setOrRemoveAttribute(control, 'tabindex', tabindex);
      setOrRemoveAttribute(control, 'aria-label', ariaLabel);
    });

    photoEditorNativeControlHomes = [];
    photoEditorNativeControls = [];
  }

  function runPhotoEditorAction(action, recordAction = true) {
    const control = PHOTO_EDITOR_CONTROL_MAP[action];
    const nativeControls = getNativePhotoControls();
    const nativeControl = control ? nativeControls[control.index] : null;
    if (!nativeControl) return false;

    const clickTarget = getNativePhotoControlClickTarget(nativeControl);
    if (!clickTarget) return false;

    isDispatchingPhotoEditorAction = true;
    try {
      for (let clickIndex = 0; clickIndex < control.clicks; clickIndex += 1) {
        clickTarget.click();
      }
    } finally {
      isDispatchingPhotoEditorAction = false;
    }

    if (recordAction && !isRevertingPhotoEditor) photoEditorActionHistory.push(action);
    return true;
  }

  function getPhotoEditorPinchDistance(touches) {
    return Math.hypot(
      touches[1].clientX - touches[0].clientX,
      touches[1].clientY - touches[0].clientY
    );
  }

  function startPhotoEditorPinch(event) {
    if (event.touches.length !== 2) return;
    event.preventDefault();
    event.stopPropagation();

    photoEditorPinchState = {
      startDistance: Math.max(1, getPhotoEditorPinchDistance(event.touches)),
      appliedSteps: 0
    };
    event.currentTarget.classList.add('is-pinching');
  }

  function movePhotoEditorPinch(event) {
    if (!photoEditorPinchState || event.touches.length !== 2) return;
    event.preventDefault();
    event.stopPropagation();

    const distance = Math.max(1, getPhotoEditorPinchDistance(event.touches));
    const scale = distance / photoEditorPinchState.startDistance;
    const targetSteps = Math.max(-12, Math.min(12, Math.trunc(Math.log(scale) / Math.log(1.08))));
    let stepDifference = targetSteps - photoEditorPinchState.appliedSteps;

    while (stepDifference !== 0) {
      const action = stepDifference > 0 ? 'zoom-in' : 'zoom-out';
      if (!runPhotoEditorAction(action)) break;
      photoEditorPinchState.appliedSteps += stepDifference > 0 ? 1 : -1;
      stepDifference = targetSteps - photoEditorPinchState.appliedSteps;
    }
  }

  function endPhotoEditorPinch(event) {
    if (!photoEditorPinchState || event.touches.length >= 2) return;
    event.preventDefault();
    event.stopPropagation();
    photoEditorPinchState = null;
    event.currentTarget.classList.remove('is-pinching');
  }

  function restorePhotoEditorCanvas() {
    if (!photoEditorCanvasWrapper) return;

    if (photoEditorCanvasPlaceholder?.parentNode) {
      photoEditorCanvasPlaceholder.parentNode.insertBefore(photoEditorCanvasWrapper, photoEditorCanvasPlaceholder);
      photoEditorCanvasPlaceholder.remove();
    }

    photoEditorCanvasWrapper.classList.remove('dm-customily-photo-editor__canvas');
    photoEditorCanvasWrapper = null;
    photoEditorCanvasPlaceholder = null;
    window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
  }

  function revertPhotoEditorActions() {
    if (!photoEditorActionHistory.length) return;

    isRevertingPhotoEditor = true;
    [...photoEditorActionHistory].reverse().forEach((action) => {
      const inverse = PHOTO_EDITOR_CONTROL_MAP[action]?.inverse;
      if (inverse) runPhotoEditorAction(inverse, false);
    });
    isRevertingPhotoEditor = false;
  }

  function closePhotoEditor({ revert = true, restoreFocus = true } = {}) {
    const modal = document.getElementById(PHOTO_EDITOR_MODAL_ID);
    if (!modal?.classList.contains('is-open')) return;

    if (revert) revertPhotoEditorActions();
    restoreNativePhotoControls();
    restorePhotoEditorCanvas();
    setPhotoEditorBackgroundInert(false);
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dm-customily-photo-editor-open');
    photoEditorActionHistory = [];
    photoEditorPinchState = null;
    modal.querySelector('[data-photo-editor-preview]')?.classList.remove('is-pinching');

    if (restoreFocus && photoEditorLastFocus?.isConnected) {
      photoEditorLastFocus.focus({ preventScroll: true });
    }
    photoEditorLastFocus = null;
  }

  function openPhotoEditor() {
    const root = document.querySelector(ROOT_SELECTOR);
    if (!root?.classList.contains('dm-customily-upload-has-file')) return false;

    const canvasWrapper = getPhotoEditorCanvasWrapper();
    if (!canvasWrapper) return false;

    const modal = ensurePhotoEditorModal();
    const preview = modal.querySelector('[data-photo-editor-preview]');
    const nativeControls = Array.from(canvasWrapper.querySelectorAll('.customily-mobile-controls .cl-mobile-control-wrapper'));
    if (!preview || nativeControls.length < 7) return false;

    photoEditorLastFocus = document.activeElement;
    photoEditorActionHistory = [];
    photoEditorCanvasWrapper = canvasWrapper;
    photoEditorCanvasPlaceholder = document.createComment('dm-customily-photo-editor-canvas');
    canvasWrapper.parentNode.insertBefore(photoEditorCanvasPlaceholder, canvasWrapper);
    preview.appendChild(canvasWrapper);
    canvasWrapper.classList.add('dm-customily-photo-editor__canvas');
    if (!mountNativePhotoControls(modal)) {
      restorePhotoEditorCanvas();
      return false;
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dm-customily-photo-editor-open');
    setPhotoEditorBackgroundInert(true);
    modal.querySelector('.dm-customily-photo-editor__dialog')?.focus({ preventScroll: true });
    window.requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
    return true;
  }

  function getUploadProcessingStep(progress) {
    if (progress >= 100) return UPLOAD_PROCESSING_STEPS[UPLOAD_PROCESSING_STEPS.length - 1];

    return UPLOAD_PROCESSING_STEPS.find((step) => progress >= step.start && progress < step.end) || UPLOAD_PROCESSING_STEPS[0];
  }

  function syncUploadProcessingProgressToTime() {
    if (!processingStartedAt) return;

    const elapsed = Math.min(Date.now() - processingStartedAt, PROCESSING_MIN_VISIBLE_MS);
    const progressRange = PROCESSING_PENDING_MAX_PROGRESS - PROCESSING_INITIAL_PROGRESS;
    const progress = PROCESSING_INITIAL_PROGRESS + (elapsed / PROCESSING_MIN_VISIBLE_MS) * progressRange;

    setUploadProcessingProgress(Math.min(progress, PROCESSING_PENDING_MAX_PROGRESS));
  }

  function setUploadProcessingProgress(progress) {
    uploadProcessingProgress = Math.max(PROCESSING_INITIAL_PROGRESS, Math.min(100, progress));
    const modal = document.getElementById(UPLOAD_PROCESSING_MODAL_ID);
    if (!modal) return;

    const step = getUploadProcessingStep(uploadProcessingProgress);
    const nextStep = String(step.step);
    const previousStep = modal.dataset.processingStep;
    const stepChanged = Boolean(previousStep && previousStep !== nextStep);
    modal.dataset.processingStep = nextStep;

    if (stepChanged) {
      window.clearTimeout(processingStepAnimationTimer);
      modal.classList.remove('is-step-changing');
      void modal.offsetWidth;
      modal.classList.add('is-step-changing');
      processingStepAnimationTimer = window.setTimeout(() => {
        modal.classList.remove('is-step-changing');
        processingStepAnimationTimer = 0;
      }, 560);
    }

    const stepElement = modal.querySelector('[data-upload-processing-step]');
    const iconElement = modal.querySelector('[data-upload-processing-icon]');
    const titleElement = modal.querySelector('[data-upload-processing-title]');
    const descriptionElement = modal.querySelector('[data-upload-processing-description]');
    const barElement = modal.querySelector('[data-upload-processing-bar]');
    const statusElement = modal.querySelector('[data-upload-processing-status]');
    const markerElements = modal.querySelectorAll('[data-upload-processing-marker]');

    if (stepElement) stepElement.textContent = `Step ${step.step} of 4`;
    if (iconElement && iconElement.dataset.step !== String(step.step)) {
      iconElement.dataset.step = String(step.step);
      iconElement.innerHTML = step.icon;
    }
    if (titleElement) titleElement.textContent = step.title;
    if (descriptionElement) descriptionElement.textContent = step.description;
    if (barElement) barElement.style.width = `${uploadProcessingProgress}%`;
    if (statusElement) {
      const isComplete = uploadProcessingProgress >= 100;
      const statusProgress = isComplete ? 100 : Math.min(uploadProcessingProgress, PROCESSING_PENDING_MAX_PROGRESS);
      statusElement.textContent = isComplete ? '✓' : `${Math.round(statusProgress)}%`;
      statusElement.classList.toggle('is-complete', isComplete);
    }
    markerElements.forEach((markerElement) => {
      const markerStep = Number(markerElement.dataset.uploadProcessingMarker);
      markerElement.classList.toggle('is-active', markerStep <= step.step);
      markerElement.classList.toggle('is-complete', uploadProcessingProgress >= 100);
    });
    applyUploadProcessingModalFonts(modal);
  }

  function openUploadProcessingModal() {
    const modal = ensureUploadProcessingModal();

    window.clearInterval(processingProgressTimer);
    window.clearTimeout(processingModalCloseTimer);
    setUploadProcessingProgress(PROCESSING_INITIAL_PROGRESS);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dm-customily-upload-processing-open');

    processingProgressTimer = window.setInterval(() => {
      syncUploadProcessingProgressToTime();
    }, 250);
    syncUploadProcessingProgressToTime();
  }

  function closeUploadProcessingModal() {
    window.clearInterval(processingProgressTimer);
    window.clearTimeout(processingModalCloseTimer);
    window.clearTimeout(processingStepAnimationTimer);
    processingProgressTimer = 0;
    processingStepAnimationTimer = 0;

    const modal = document.getElementById(UPLOAD_PROCESSING_MODAL_ID);
    if (!modal) return;

    setUploadProcessingProgress(100);
    processingModalCloseTimer = window.setTimeout(() => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('dm-customily-upload-processing-open');
      processingModalCloseTimer = 0;
      if (pendingPhotoEditorOpen) {
        pendingPhotoEditorOpen = false;
        window.requestAnimationFrame(openPhotoEditor);
      }
    }, 520);
  }

  function setUploadButtonLoading(control) {
    const root = document.querySelector(ROOT_SELECTOR);
    activeUploadControl = control || activeUploadControl || root?.querySelector(`.${UPLOAD_CONTROL_CLASS}`) || getSelectImageControl(root);

    root?.classList.add('dm-customily-upload-loading');
    activeUploadControl?.classList.add('dm-customily-upload-loading-button');
    activeUploadControl?.setAttribute('aria-busy', 'true');
  }

  function clearUploadButtonLoading() {
    document.querySelector(ROOT_SELECTOR)?.classList.remove('dm-customily-upload-loading');
    document.querySelectorAll(`.${UPLOAD_CONTROL_CLASS}, .dm-customily-upload-loading-button`).forEach((control) => {
      control.classList.remove('dm-customily-upload-loading-button');
      control.removeAttribute('aria-busy');
    });

    activeUploadControl = null;
  }

  function startUploadProcessing(control) {
    closePhotoEditor({ revert: false, restoreFocus: false });
    pendingPhotoEditorOpen = true;
    processingStartedAt = Date.now();
    processingInitialSignature = '';
    window.clearTimeout(processingSettleTimer);
    window.clearTimeout(processingMaxTimer);
    window.clearTimeout(processingCheckTimer);

    setUploadButtonLoading(control);
    openUploadProcessingModal();
    if (PROCESSING_MAX_VISIBLE_MS > 0) {
      processingMaxTimer = window.setTimeout(stopUploadProcessing, PROCESSING_MAX_VISIBLE_MS);
    }
  }

  function stopUploadProcessing() {
    if (!processingStartedAt) return;

    processingStartedAt = 0;
    processingInitialSignature = '';
    window.clearTimeout(processingSettleTimer);
    window.clearTimeout(processingMaxTimer);
    window.clearTimeout(processingCheckTimer);
    clearUploadButtonLoading();
    closeUploadProcessingModal();
  }

  function scheduleProcessingDone() {
    if (!processingStartedAt) return;
  }

  function mutationTouchesPhotoProcessingTarget(mutation) {
    const target = mutation.target instanceof Element ? mutation.target : mutation.target?.parentElement;
    if (target?.closest?.('#customily-options, #pwzrswiper-container-wrapper, .rio-media-gallery, .cl-canvas-container')) return true;

    return Array.from(mutation.addedNodes).some((node) => {
      const element = node instanceof Element ? node : node.parentElement;
      return element?.matches?.('#customily-options, #pwzrswiper-container-wrapper, .rio-media-gallery, .cl-canvas-container, img, canvas') ||
        element?.querySelector?.('#customily-options, #pwzrswiper-container-wrapper, .rio-media-gallery, .cl-canvas-container, img, canvas');
    });
  }

  function openGuidelinesModal(trigger) {
    lastGuidelinesTrigger = trigger || document.activeElement;
    const modal = ensureGuidelinesModal();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dm-photo-guidelines-open');
    modal.querySelector('.dm-photo-guidelines-modal__dialog')?.focus({ preventScroll: true });
  }

  function closeGuidelinesModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dm-photo-guidelines-open');

    if (lastGuidelinesTrigger?.isConnected) {
      lastGuidelinesTrigger.focus({ preventScroll: true });
    }
  }

  function enhancePhotoGuidelines(root) {
    const existing = root.querySelector(`.${TRIGGER_CLASS}`);

    root.classList.remove(CONDITIONS_HIDDEN_CLASS);

    if (!customilyRootHasVisibleConditionContent(root)) {
      existing?.remove();
      resetPhotoUploadLayout(root);
      root.classList.add(CONDITIONS_HIDDEN_CLASS);
      return;
    }

    if (!customilyRootHasPhotoUpload(root)) {
      existing?.remove();
      resetPhotoUploadLayout(root);
      return;
    }

    normalizePhotoUploadLayout(root);

    if (existing) return;

    const trigger = createGuidelinesTrigger();
    const insertTarget = root.querySelector(`.${PERSONALIZED_TITLE_CLASS}`) || getGuidelinesInsertTarget(root);

    if (insertTarget) {
      insertTarget.insertAdjacentElement('afterend', trigger);
    } else {
      root.insertBefore(trigger, root.firstChild);
    }
  }

  function enhanceAllPhotoGuidelines() {
    enhanceRaf = 0;
    document.querySelectorAll(ROOT_SELECTOR).forEach(enhancePhotoGuidelines);
  }

  function scheduleEnhancePhotoGuidelines() {
    window.cancelAnimationFrame(enhanceRaf);
    enhanceRaf = window.requestAnimationFrame(enhanceAllPhotoGuidelines);
  }

  document.addEventListener('click', function (event) {
    const nativeEditorAction = event.target.closest?.('[data-photo-editor-native-action]');
    if (nativeEditorAction) {
      if (!isRevertingPhotoEditor && !isDispatchingPhotoEditorAction) {
        photoEditorActionHistory.push(nativeEditorAction.dataset.photoEditorNativeAction);
      }
      return;
    }

    const editorAction = event.target.closest?.('[data-photo-editor-action]');
    if (editorAction) {
      event.preventDefault();
      runPhotoEditorAction(editorAction.dataset.photoEditorAction);
      return;
    }

    if (event.target.closest?.('[data-photo-editor-apply]')) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('dm:customily-photo-editor-apply'));
      closePhotoEditor({ revert: false });
      return;
    }

    if (event.target.closest?.('[data-photo-editor-replace]')) {
      event.preventDefault();
      const root = document.querySelector(ROOT_SELECTOR);
      const control = root?.querySelector(`.${UPLOAD_CONTROL_CLASS}`) || getSelectImageControl(root) || root?.querySelector('input[type="file"]');
      if (!control) return;

      uploadPickerExpectedUntil = Date.now() + 12000;
      activeUploadControl = control;
      setPhotoEditorBackgroundInert(false);
      control.click();
      window.requestAnimationFrame(() => {
        const modal = document.getElementById(PHOTO_EDITOR_MODAL_ID);
        if (modal?.classList.contains('is-open')) setPhotoEditorBackgroundInert(true);
      });
      return;
    }

    if (event.target.closest?.('[data-photo-editor-close]')) {
      event.preventDefault();
      closePhotoEditor();
      return;
    }

    if (event.target.closest?.(`.${UPLOAD_EDIT_ACTION_CLASS}`)) {
      event.preventDefault();
      openPhotoEditor();
      return;
    }

    const uploadAction = event.target.closest?.(`.${UPLOAD_ACTION_CLASS}`);
    if (uploadAction) {
      const root = uploadAction.closest(ROOT_SELECTOR);
      if (triggerUploadControl(root, uploadAction._dmUploadControl, event)) return;
    }

    if (triggerUploadControlFromWrapper(event.target.closest?.(`.${UPLOAD_WRAP_CLASS}`), event)) return;

    const uploadControl = event.target.closest?.(`.${UPLOAD_CONTROL_CLASS}`);
    if (uploadControl) {
      if (uploadControl._dmSuppressUploadClick) {
        uploadControl._dmSuppressUploadClick = false;
        return;
      }

      uploadPickerExpectedUntil = Date.now() + 12000;
      activeUploadControl = uploadControl;
    }

    const trigger = event.target.closest?.(`.${TRIGGER_CLASS}`);
    if (trigger) {
      event.preventDefault();
      openGuidelinesModal(trigger);
      return;
    }

    if (event.target.closest?.('[data-photo-guidelines-close]')) {
      event.preventDefault();
      closeGuidelinesModal();
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'file') return;
    if (!input.files?.length) return;
    if (!input.closest(ROOT_SELECTOR) && Date.now() > uploadPickerExpectedUntil) return;

    uploadPickerExpectedUntil = 0;
    startUploadProcessing(activeUploadControl);
  }, true);

  document.addEventListener('keydown', function (event) {
    const nativeEditorAction = event.target.closest?.('[data-photo-editor-native-action]');
    if (nativeEditorAction && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      getNativePhotoControlClickTarget(nativeEditorAction)?.click();
      return;
    }

    if (event.key !== 'Escape') return;
    const photoEditor = document.getElementById(PHOTO_EDITOR_MODAL_ID);
    if (photoEditor?.classList.contains('is-open')) {
      closePhotoEditor();
      return;
    }
    const modal = document.getElementById(MODAL_ID);
    if (!modal?.classList.contains('is-open')) return;
    closeGuidelinesModal();
  });

  document.addEventListener('DOMContentLoaded', function () {
    scheduleEnhancePhotoGuidelines();

    if (!window.MutationObserver) return;

    const observer = new MutationObserver(scheduleEnhancePhotoGuidelines);
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    const processingObserver = new MutationObserver(function (mutations) {
      if (!processingStartedAt || !mutations.some(mutationTouchesPhotoProcessingTarget)) return;
      scheduleProcessingDone();
    });
    processingObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'style', 'src'],
      childList: true,
      subtree: true
    });
  });

  window.addEventListener('load', scheduleEnhancePhotoGuidelines);
  document.addEventListener('variant:change', scheduleEnhancePhotoGuidelines);
})();
